// generated by stuff/i18n.py. DO NOT EDIT.
const translations: { [key: string]: string; } = {
  U13CannotPerform: "Coder menor de 13 anos n\u00e3o pode realizar esta a\u00e7\u00e3o.",
  aboutToStart: "Voc\u00ea est\u00e1 prestes a iniciar o concurso. Seu tempo come\u00e7ar\u00e1 depois de clicar em Come\u00e7ar Concurso.",
  acceptPrivacyPolicy: "Li e aceito a [Pol\u00edtica de Uso e Privacidade](%(PrivacyPolicyURL)) do site, bem como o [C\u00f3digo de Conduta](%(CodeofConductPolicyURL)).",
  accountDeleteCancel: "Cancelar",
  accountDeleteConfirmationMessage: "Tem certeza de que deseja excluir sua conta?",
  accountDeleteMessage: "Clique no bot\u00e3o abaixo se desejar excluir sua conta e todas as suas informa\u00e7\u00f5es pessoais do omegaUp. Esta opera\u00e7\u00e3o ser\u00e1 realizada imediatamente assim que voc\u00ea confirmar que deseja realiz\u00e1-la e n\u00e3o \u00e9 revers\u00edvel.",
  accountDeleteOk: "Excluir",
  accountDeleteRequireConfirmation: "Necess\u00e1ria Confirma\u00e7\u00e3o",
  accountDeletionConfirmEmailBody: "%(username) confirmado para excluir sua conta.",
  accountDeletionConfirmEmailSubject: "Confirma\u00e7\u00e3o de exclus\u00e3o de conta omegaUp",
  accountDeletionRequestEmailBody: "%(username) est\u00e1 solicitando a exclus\u00e3o de sua conta.",
  accountDeletionRequestEmailSubject: "Solicita\u00e7\u00e3o de exclus\u00e3o de conta omegaUp",
  activityReport: "Relat\u00f3rio de atividade",
  activityReportDuplicatesForOriginsDescription: "Origens com mais do que uma conta",
  activityReportDuplicatesForUsersDescription: "Contas com mais de uma origem",
  activityReportEvent: "Evento",
  activityReportNoDuplicatesForOrigins: "N\u00e3o h\u00e1 origens com mais do que uma conta",
  activityReportNoDuplicatesForUsers: "N\u00e3o h\u00e1 contas com mais de uma origem",
  activityReportOrigin: "Origen",
  activityReportOrigins: "Origens",
  activityReportReport: "Rel\u00e1torio",
  activityReportSummaryContest: "Este \u00e9 um relat\u00f3rio da atividade que aconteceu neste concurso. Para proteger a privacidade dos participantes, seus endere\u00e7os IP foram ofuscados utilizando um hash perfeito. Isso significa que h\u00e1 uma correspond\u00eancia de um-para-um entre os endere\u00e7os IP e as identifica\u00e7\u00f5es de Origem.",
  activityReportSummaryCourse: "Este \u00e9 um relat\u00f3rio da atividade que aconteceu neste curso. Para proteger a privacidade dos participantes, seus endere\u00e7os IP foram ofuscados utilizando um hash perfeito. Isso significa que h\u00e1 uma correspond\u00eancia de um-para-um entre os endere\u00e7os IP e as identifica\u00e7\u00f5es de Origem.",
  activityReportUsers: "Nome da conta",
  addContestUsernameAndPassword: "Se participou num concurso e lhe foi atribu\u00edda uma nova conta, adicione-a aqui para a ligar \u00e0 sua conta principal.",
  addUsersMultipleOrSingleUser: "Adicionar uma ou v\u00e1rias contas",
  addUsersToReviewerGroup: "Clique para adicionar uma conta \u00e0 lista de revisores.",
  adminAdded: "Administrador adicionado com sucesso",
  adminRemoved: "Administrador removido com sucesso",
  adminSupportEmailUpdatedSuccessfully: "Email atualizado com sucesso",
  adminSupportPageNotFound: "P\u00e1gina n\u00e3o encontrada",
  adminSupportTypeNewEmail: "Digite um novo e-mail",
  admissionModeManualOnly: "Manual (Adicionar os nomes das contas dos seus estudantes)",
  admissionModePublic: "P\u00fablico (Os alunos se inscrevem apenas com o link do curso)",
  admissionModeShareURL: "Compartilhar URL (os alunos se inscrevem na URL)",
  aliasAlreadyInUse: "Alias \"%(alias)\" j\u00e1 existe. Por favor, escolha um nome diferente.",
  aliasInUse: "Alias j\u00e1 existe. Por favor, escolha um alias diferente.",
  allowedSolutionsLimitReached: "Voc\u00ea tem alcan\u00e7ado o limite de solu\u00e7\u00f5es permitidas",
  apiNotFound: "Endpoint API solicitada n\u00e3o foi encontrado.",
  apiTokenAdd: "Adicionar token de API",
  apiTokenDescription: "Se quiser utilizar a API omegaup, pode criar um token API, cada token API pode fazer at\u00e9 1000 pedidos por hora e pode ter at\u00e9 5 tokens API.",
  apiTokenLastTimeUsed: "\u00daltima utiliza\u00e7\u00e3o",
  apiTokenLimit: "Limite",
  apiTokenLimitExceeded: "N\u00famero m\u00e1ximo de tokens da API excedido.",
  apiTokenName: "Nome do token",
  apiTokenNameAlreadyInUse: "Os nomes de tokens da API devem ser exclusivos",
  apiTokenRateLimitExceeded: "N\u00famero m\u00e1ximo de solicita\u00e7\u00f5es da API excedido. Por favor, tente novamente mais tarde.",
  apiTokenRemaining: "Restante",
  apiTokenResetTime: "Redefinir tempo",
  apiTokenRevoke: "Revogar API token",
  apiTokenSuccessfullyCreated: "Token criado com sucesso, copie o token, uma vez que ser\u00e1 apresentado apenas uma vez: %(token)",
  apiTokenSuccessfullyRevoked: "Token revogado com sucesso",
  apiTokenTimestamp: "Carimbo do tempo",
  arbitrateRequestAcceptSuccessfully: "O pedido foi aprovado com sucesso",
  arbitrateRequestDenySuccessfully: "O pedido foi negado com sucesso",
  arenaClarificationCreate: "Digite sua pergunta aqui",
  arenaClarificationMaxLength: "No m\u00e1ximo 200 caracteres, n\u00e3o incluir o seu c\u00f3digo completo.",
  arenaCommonCode: "C\u00f3digo",
  arenaCommonMemoryLimit: "Limite de mem\u00f3ria",
  arenaCommonOverallWallTimeLimit: "Prazo (total)",
  arenaCommonTimeLimit: "Limite de tempo (caso)",
  arenaContestEndedUsePractice: "Este concurso terminou. Para continuar a enviar solu\u00e7\u00f5es use o Modo de Pr\u00e1tica clicando aqui.",
  arenaContestHasAlreadyStarted: "Este concurso j\u00e1 come\u00e7ou",
  arenaContestNotOpened: "Voc\u00ea precisa abrir o conjunto de problemas no modo n\u00e3o administrativo para fazer envios.",
  arenaContestOrganizer: "Organizador",
  arenaContestPracticeOriginalRunsText: "Para ver as solu\u00e7\u00f5es do concurso original, clique [aqui](/arena/%(contestAlias)/#runs)",
  arenaContestPracticeOriginalScoreboardText: "Para ver o painel de avalia\u00e7\u00e3o, clique [aqui](/arena/%(contestAlias)/#ranking)",
  arenaContestWindowLength: "Tempo de resolver todos os problemas",
  arenaCourseAllContent: "Todo o conte\u00fado",
  arenaCourseAssignmentHasAlreadyStarted: "Este conte\u00fado j\u00e1 come\u00e7ou",
  arenaCourseAssignmentWillBeginIn: "Este conte\u00fado inciar\u00e1 em %(time)",
  arenaCourseProblemTitle: "%(letter). %(title)",
  arenaPageRecommendedContestsText: "Para mostrar seus concursos na lista de Concursos Recomendados, entre em contato soporte@omegaup.com.",
  arenaPageTitle: "omegaUp Arena",
  arenaPracticeEndtime: "Tempo Final",
  arenaPracticeScoreboardCutoff: "Tempo de corte do painel de avalia\u00e7\u00e3o",
  arenaPracticeStartTime: "Hora de in\u00edcio",
  arenaRunSubmitEmptyCode: "N\u00e3o \u00e9 poss\u00edvel enviar c\u00f3digo vazio",
  arenaRunSubmitFilename: "Nome do arquivo do seu c\u00f3digo ser\u00e1: ",
  arenaRunSubmitFilesize: "O limite para upload de arquivos s\u00e3o %(limit)",
  arenaRunSubmitMissingLanguage: "Voc\u00ea deve escolher um idioma",
  arenaRunSubmitPaste: "Cole o c\u00f3digo do seu programa aqui",
  arenaRunSubmitUpload: "Ou fa\u00e7a upload de um arquivo",
  arenaRunSubmitWaitBetweenUploads: "Voc\u00ea tem que esperar %(submissionGap) segundos antes de fazer outro envio para este problema",
  arenaRunsActions: "A\u00e7\u00f5es",
  arenaRunsActionsDetails: "Detalhes",
  arenaRunsActionsDisqualified: "Desqualificado",
  arenaRunsActionsDisqualifyByGUID: "Desqualificar submis\u00e3o",
  arenaRunsActionsDisqualifyByProblem: "Desqualificar todas as submiss\u00f5es do usu\u00e1rio para este problema.",
  arenaRunsActionsDisqualifyByUser: "Desqualificar todas as submiss\u00f5es do usu\u00e1rio para este concurso.",
  arenaRunsActionsRejudge: "Revaluar",
  arenaRunsActionsRequalify: "Requalificar",
  arrayEditTitle: "Editor de array",
  arrayModalBack: "Voltar",
  arrayModalDistinctValues: "Valores distintos",
  arrayModalGenerate: "Gerar",
  arrayModalGeneratedArray: "Array gerado",
  arrayModalMaximum: "M\u00e1ximo",
  arrayModalMinimum: "M\u00ednimo",
  arrayModalSave: "Salvar",
  arrayModalSize: "Tamanho",
  assignmentCardLessons: "%(lessonCount) li\u00e7\u00f5es",
  assignmentCardProblems: "%(problemCount) problemas",
  assignmentCardStart: "Come\u00e7ar",
  assignmentNotFound: "Conte\u00fado n\u00e3o encontrado",
  assignmentNotStarted: "A li\u00e7\u00e3o ainda n\u00e3o tem come\u00e7ado",
  assignmentRemoveAlreadyHasRuns: "Conte\u00fado n\u00e3o pode ser removida depois que uma solu\u00e7\u00e3o \u00e9 julgada.",
  authorRankRangeHeader: "Contribuintes com maior score obtido (%(lowCount) a %(highCount))",
  authorRankUnranked: "Autor n\u00e3o classificado",
  badgeAssignationTimeMessage: "Data que voc\u00ea recebeu este crach\u00e1",
  badgeFirstAssignationMessage: "A primeira vez que este crach\u00e1 foi atribu\u00eddo",
  badgeNotAssignedMessage: "Voc\u00ea ainda n\u00e3o tem este crach\u00e1",
  badgeNotExist: "O crach\u00e1 n\u00e3o existe.",
  badgeOwnersMessage: "Coders que receberam este crach\u00e1",
  badge_100solvedProblems_description: "Concedido a pessoas que resolveram 100 ou mais problemas.",
  badge_100solvedProblems_name: "100 Problemas Resolvidos",
  badge_15dayStreak_description: "Concedido a pessoas que mantiveram uma sequ\u00eancia de 15 dias consecutivos.",
  badge_15dayStreak_name: "Sequ\u00eancia de 15 dias",
  badge_30dayStreak_description: "Concedido a pessoas que mantiveram uma sequ\u00eancia de 30 dias consecutivos.",
  badge_30dayStreak_name: "Sequ\u00eancia de 30 dias",
  badge_500score_description: "Concedido a pessoas que obtiveram pontua\u00e7\u00e3o igual ou superior a 500.",
  badge_500score_name: "Pontua\u00e7\u00e3o 500",
  badge_7dayStreak_description: "Concedido a pessoas que mantiveram uma sequ\u00eancia de 7 dias consecutivos.",
  badge_7dayStreak_name: "Sequ\u00eancia de 7 dias",
  badge_christmasProblem2021_description: "Concedido ao usu\u00e1rio que participou do concurso A Problem for Christmas 2021 apresentando problemas originais com temas natalinos.",
  badge_christmasProblem2021_name: "Problema de Natal 2021",
  badge_coderOfTheMonth_description: "Concedido a pessoas que foram nomeadas Coder do M\u00eas pelo menos uma vez.",
  badge_coderOfTheMonth_name: "Programador do M\u00eas",
  badge_contestManager_description: "Concedido a pessoas que administraram pelo menos um concurso.",
  badge_contestManager_name: "Admin do Concurso",
  badge_cppCourseGraduate_description: "Concedido a pessoas que resolveram mais do 60% do curso de Introdu\u00e7\u00e3o ao C++.",
  badge_cppCourseGraduate_name: "Aprovou o curso de Introdu\u00e7\u00e3o ao C++",
  badge_cppExpert_description: "Concedido a pessoas que resolveram mais de 10 problemas em C++.",
  badge_cppExpert_name: "Especialista em C++",
  badge_feedbackProvider_description: "Concedido a pessoas que enviaram uma classifica\u00e7\u00e3o para pelo menos um problema.",
  badge_feedbackProvider_name: "Provedor de Feedback",
  badge_introToAlgorithms2CourseGraduate_description: "Concedido a pessoas que resolveram mais do 70% do curso de Introdu\u00e7\u00e3o aos Algoritmos II.",
  badge_introToAlgorithms2CourseGraduate_name: "Aprovou o curso de Introdu\u00e7\u00e3o aos Algoritmos II",
  badge_introToAlgorithmsCourseGraduate_description: "Concedido a pessoas que resolveram mais do 70% do curso de Introdu\u00e7\u00e3o aos Algoritmos I.",
  badge_introToAlgorithmsCourseGraduate_name: "Aprovou o curso de Introdu\u00e7\u00e3o aos Algoritmos I",
  badge_javaExpert_description: "Concedido a pessoas que resolveram mais de 10 problemas em Java.",
  badge_javaExpert_name: "Especialista em Java",
  badge_karelExpert_description: "Concedido a pessoas que resolveram mais de 10 problemas em Karel.",
  badge_karelExpert_name: "Especialista em Karel",
  badge_legacyUser_description: "Concedido a pessoas que enviaram uma solu\u00e7\u00e3o h\u00e1 mais de 3 anos.",
  badge_legacyUser_name: "Trajet\u00f3ria Hist\u00f3rica",
  badge_pascalExpert_description: "Concedido a pessoas que resolveram mais de 10 problemas em Pascal.",
  badge_pascalExpert_name: "Especialista em Pascal",
  badge_problemOfTheWeekWithOmegaUp_description: "Concedido a pessoas que resolveram um problema do curso de Resolvendo Problemas em omegaUp.",
  badge_problemOfTheWeekWithOmegaUp_name: "Problema de semana com omegaUp",
  badge_problemSetter_description: "Concedido a pessoas que criaram pelo menos um problema.",
  badge_problemSetter_name: "Criador de Problemas",
  badge_pythonCourseGraduate_description: "Concedido a pessoas que resolveram mais do 90% do curso de Introdu\u00e7\u00e3o ao Python.",
  badge_pythonCourseGraduate_name: "Aprovou o curso de Introdu\u00e7\u00e3o ao Python",
  badge_pythonExpert_description: "Concedido a pessoas que resolveram mais de 10 problemas em Python.",
  badge_pythonExpert_name: "Especialista em Python",
  badge_updatedUser_description: "Concedido \u00e0s pessoas que completaram as informa\u00e7\u00f5es em seu perfil.",
  badge_updatedUser_name: "Perfil Atualizado",
  badge_virtualContestManager_description: "Concedido a pessoas que administraram pelo menos um concurso virtual.",
  badge_virtualContestManager_name: "Admin do Concurso Virtual",
  banProblemFormComments: "Coment\u00e1rios adicionais para o criador do problema",
  banProblemFormQuestion: "Por que esse problema ser\u00e1 banido?",
  bannerLastDayToVerifyAccount: "Aten\u00e7\u00e3o! Resta apenas 1 dia para que seu pai ou tutor aprove sua conta. Caso contr\u00e1rio, sua conta ser\u00e1 exclu\u00edda.",
  bannerVerifyAccount: "\u00c9 necess\u00e1rio que seu pai ou tutor aprove sua conta dentro de %(days) dias. Caso contr\u00e1rio, sua conta ser\u00e1 exclu\u00edda.",
  banningDeclinedByReviewer: "Proibi\u00e7\u00e3o negada pelo revisor.",
  banningProblemDueToReport: "Banido problema devido a um relat\u00f3rio de conta.",
  birthdayInTheFuture: "Voc\u00ea n\u00e3o tem idade suficiente para usar omegaUp",
  bulkOperationError: "Ocorreu um erro ao executar a opera\u00e7\u00e3o",
  bulkUserAddError: "Ocorreu um erro ao adicionar contas. Os seguintes nomes ou emails n\u00e3o foram encontrados no omegaUp:<br><br><b>%(userEmail)</b>.<br><br>No entanto, todas as outras contas foram adicionadas corretamente.",
  bulkUserAddSuccess: "Contas adicionadas com sucesso!",
  buttonCreateContest: "Criar um concurso",
  buttonCreateProblem: "Criar um problema",
  buttonGoToContests: "Ir para concursos",
  buttonGoToCourses: "Ir para cursos",
  buttonGoToProblems: "Ir para problemas",
  cannotAddProb: "N\u00e3o \u00e9 poss\u00edvel adicionar problema. Voc\u00ea n\u00e3o \u00e9 o diretor do concurso.",
  cannotRemoveProblem: "N\u00e3o \u00e9 poss\u00edvel eliminar problema. Voc\u00ea n\u00e3o \u00e9 o diretor do concurso.",
  cannotRemoveProblemWithSubmissions: "Voc\u00ea n\u00e3o pode eliminar um problema que j\u00e1 tenha solu\u00e7\u00f5es",
  caseEditTitle: "Editar caso",
  caseModalBack: "Voltar",
  caseModalSave: "Salvar",
  certificateDetailsBody: "Envie-nos um e-mail para [certificates@omegaup.com](mailto:certificates@omegaup.com?subject=Verificar%20diploma%20%(uuid)) para verificar um diploma. Certifique-se de incluir o ID do diploma (%(uuid)) no assunto.",
  certificateDetailsTitle: "Processo de verifica\u00e7\u00e3o de diploma",
  certificateListMineActions: "A\u00e7\u00f5es",
  certificateListMineCertificatesEmpty: "Sem diplomas",
  certificateListMineCoderOfTheMonth: "Coder do m\u00eas",
  certificateListMineCoderOfTheMonthFemale: "Coder do m\u00eas para eles",
  certificateListMineContest: "Concurso \"%(contest_title)\"",
  certificateListMineCopyToClipboard: "Copiar a liga\u00e7\u00e3o de verifica\u00e7\u00e3o",
  certificateListMineCourse: "Curso \"%(course_name)\"",
  certificateListMineDate: "Data",
  certificateListMineDownload: "Baixe o diploma",
  certificateListMineFileDownloaded: "O diploma foi baixado",
  certificateListMineLinkCopiedToClipboard: "O link de verifica\u00e7\u00e3o foi copiado",
  certificateListMineReason: "Raz\u00e3o",
  certificateListMineTitle: "Meus Diplomas",
  certificateListMineVerificationLink: "Link de verifica\u00e7\u00e3o",
  certificateNotFound: "Diploma n\u00e3o encontrado",
  certificatePdfCoderOfTheMonthDescription: "pelo seu desempenho no m\u00eas de %(month_name) ao marcarem o maior n\u00famero de pontos na plataforma omegaUp.com",
  certificatePdfCoderOfTheMonthFemaleTitle: "Coder do m\u00eas para eles",
  certificatePdfCoderOfTheMonthTitle: "Coder do m\u00eas",
  certificatePdfContestDescription: "pela sua participa\u00e7\u00e3o no concurso \"%(contest_title)\" que teve lugar na plataforma omegaUp.com",
  certificatePdfContestParticipation: "Participa\u00e7\u00e3o",
  certificatePdfContestPlaceNd: "\u00b0 lugar",
  certificatePdfContestPlaceRd: "\u00b0 lugar",
  certificatePdfContestPlaceSt: "\u00b0 lugar",
  certificatePdfContestPlaceTh: "\u00b0 lugar",
  certificatePdfCourseDescription: "por ter conclu\u00eddo o curso \"%(course_name)\" na plataforma omegaUp.com",
  certificatePdfCourseTitle: "Gradua\u00e7\u00e3o",
  certificatePdfDirector: "Diretor Executivo",
  certificatePdfGrantsRecognition: "Concede o reconhecimento de",
  certificatePdfHeader: "Aumentar o n\u00famero de engenheiros de software talentosos na Am\u00e9rica Latina",
  certificatePdfMonth1: "Janeiro",
  certificatePdfMonth10: "Outubro",
  certificatePdfMonth11: "Novembro",
  certificatePdfMonth12: "Dezembro",
  certificatePdfMonth2: "Fevereiro",
  certificatePdfMonth3: "Mar\u00e7o",
  certificatePdfMonth4: "Abril",
  certificatePdfMonth5: "Maio",
  certificatePdfMonth6: "Junho",
  certificatePdfMonth7: "Julho",
  certificatePdfMonth8: "Agosto",
  certificatePdfMonth9: "Setembro",
  certificatePdfPerson: "para a pessoa",
  certificatePdfPlaceAndDate: "Bellevue, Washington a %(day) de %(month) de %(year)",
  certificatePdfVerificationCode: "C\u00f3digo de verifica\u00e7\u00e3o: %(verification_code)",
  certificatePdfVerificationLink: "Link de verifica\u00e7\u00e3o: https://omegaup.com/cert/%(verification_code)/",
  certificateValidationCertifyValidity: "omegaUp certifica a validade do seguinte diploma",
  certificateValidationEnteredCode: "C\u00f3digo introduzido: ",
  certificateValidationInvalid: "Inv\u00e1lido",
  certificateValidationNotFound1: "N\u00e3o foi encontrado nenhum diploma com o c\u00f3digo ",
  certificateValidationNotFound2: " na base de dados. Se voc\u00ea acredita que isso \u00e9 um erro, contacte-nos em hello@omegaup.com.",
  certificateValidationStatus: "Status: ",
  certificateValidationTitle: "Verificar Diploma",
  clarificationContest: "Concurso:",
  clarificationEmailBody: "<p>Ol\u00e1!</p><p><strong><a href=\"https://omegaup.com/profile/%(user_name)\">%(user_name)</a></strong> solicitou um esclarecimento para o problema <strong><a href=\"https://omegaup.com/arena/problem/%(problem_alias)\">%(problem_name)</a></strong>:</p><p><blockquote><p>%(clarification_body)</p></blockquote><p>Para respond\u00ea-lo, por favor visite o seguinte link: <a href=\"%(url)\">%(url)</a>.</p><p>Obrigado,<br/>omegaUp</p>",
  clarificationEmailSubject: "[omegaUp] Novo esclarecimento para o problema %(problem_name)",
  clarificationHomework: "Tarefa:",
  clarificationInfo: "Info",
  clarificationNotFound: "Esclarecimento n\u00e3o encontrado",
  clarificationProblem: "Problema:",
  clarificationTime: "Data e Hora:",
  clarificationUpdateAnswer: "Atualizar resposta",
  clarificationsAskedBy: "A pedido de:",
  clarificationsEmpty: "Ainda n\u00e3o existem clarifica\u00e7\u00f5es",
  clarificationsOnBehalf: "%(author) (em nome de %(receiver))",
  clarificationsRangeHeader: "Clarifica\u00e7\u00f5es (da %(lowCount) \u00e0 %(highCount))",
  coderOfTheMonth: "Coder do M\u00eas Geral",
  coderOfTheMonthAlreadySelected: "O programador do m\u00eas foi selecionado anteriormente",
  coderOfTheMonthCanBeChosenManually: "Lembre-se de que voc\u00ea pode escolher os vencedores do Coder do M\u00eas para ambas as categorias na se\u00e7\u00e3o [Coder do M\u00eas](https://omegaup.com/coderofthemonth/) e na se\u00e7\u00e3o [Coder do M\u00eas para eles](https://omegaup.com/coderofthemonth/female/).",
  coderOfTheMonthChooseAsCoder: "Escolha como Programador do M\u00eas",
  coderOfTheMonthFemale: "Coder do M\u00eas para eles",
  coderOfTheMonthFemaleChooseAsCoder: "Escolha como Programador do M\u00eas feminino",
  coderOfTheMonthFemaleSelectedSuccessfully: "O codificador do m\u00eas feminino foi selecionado com sucesso!",
  coderOfTheMonthFullList: "Ver a lista completa",
  coderOfTheMonthIsNotInPeriodToBeChosen: "O codificador do m\u00eas n\u00e3o est\u00e1 no per\u00edodo a ser escolhido",
  coderOfTheMonthNotFound: "N\u00e3o foi encontrado o codificador do m\u00eas.",
  coderOfTheMonthNotice: "Ol\u00e1 %(username)! Parab\u00e9ns por ganhar reconhecimento o Coder do M\u00eas!",
  coderOfTheMonthSelectedSuccessfully: "O codificador do m\u00eas foi selecionado com sucesso!",
  coderOfTheMonthSystemInMaintainance: "O sistema de Coder do M\u00eas est\u00e1 em manuten\u00e7\u00e3o.\n\nVoltaremos em breve.",
  codersOfTheMonth: "Programadores do M\u00eas",
  codersOfTheMonthCountry: "Pa\u00eds / Regi\u00e3o",
  codersOfTheMonthDate: "Data",
  codersOfTheMonthFemale: "Programadores do M\u00eas Feminino",
  codersOfTheMonthFemaleListCandidate: "Lista de candidatos ao codificador do m\u00eas feminino",
  codersOfTheMonthFemaleRank: "Top 100 codificadoras do m\u00eas anterior",
  codersOfTheMonthListCandidate: "Lista de candidatos ao codificador do m\u00eas",
  codersOfTheMonthRank: "Top 100 codificadores do m\u00eas anterior",
  codersOfTheMonthUser: "Coder",
  collecionOtherTags: "Outras etiquetas",
  collectionTitle: "Cole\u00e7\u00f5es de problemas",
  contentCreator: "Contribuinte",
  contentOrderUpdated: "A ordem do conte\u00fado foi atualizada",
  contestAddUserContestant: "Concorrente",
  contestAddgroupAddGroup: "Adicionar grupo",
  contestAddlectureLectureName: "Leitura",
  contestAddlectureLecturePoints: "Pontos que a leitura vale",
  contestAddproblemChooseVersion: "Vers\u00e3o",
  contestAddproblemContestOrder: "Ordem concurso",
  contestAddproblemLatestVersion: "\u00daltima vers\u00e3o",
  contestAddproblemOtherVersion: "Outra vers\u00e3o",
  contestAddproblemProblemName: "Problema",
  contestAddproblemProblemOrder: "Orden",
  contestAddproblemProblemPoints: "Pontos que o problema vale",
  contestAddproblemProblemRemove: "Remover",
  contestAddproblemTooManyProblems: "Este concurso tem muitos problemas, por isso n\u00e3o \u00e9 poss\u00edvel adicionar um novo",
  contestAdduserAddContestant: "Competidors",
  contestAdduserAddUsers: "Adicionar contas",
  contestAdduserRegisteredUserDelete: "Remover",
  contestAdduserRegisteredUserTime: "Primeiro tempo de acesso",
  contestAdmissionModeDescription: "Selecione o modo do concurso. Existem tr\u00eas modalidades diferentes:\n\n- **Privado:** O concurso s\u00f3 \u00e9 vis\u00edvel para coders que foram explicitamente convidados.\n\n- **Registo/aberto:** Qualquer pessoa pode registar-se, apenas as pessoas admitidas pelos administradores t\u00eam acesso.\n\n- **P\u00fablico:** Qualquer pessoa pode participar.",
  contestAndProblemPrintButtonDesc: "imprimir",
  contestBasicInformationNeeded: "Para participar do concurso, voc\u00ea deve preencher sua informa\u00e7\u00f5e b\u00e1sica. V\u00e1 para o [Meu perfil](/profile/#edit-basic-information)",
  contestButtonEnter: "Entrar",
  contestButtonScoreboard: "Scoreboard",
  contestButtonSeeDetails: "Ver detalhes",
  contestCanNotChangeToContestForTeams: "O concurso normal n\u00e3o pode ser alterado para o concurso para equipes",
  contestCertificatesConfirmGenerate: "Tem certeza de que deseja gerar os diplomas?, uma vez gerados os diplomas n\u00e3o poder\u00e3o ser modificados. Certifique-se de que o painel de avalia\u00e7\u00e3o esteja descongelado.",
  contestCertificatesCurrentContestError: "N\u00e3o \u00e9 poss\u00edvel gerar diplomas porque o concurso ainda n\u00e3o terminou.",
  contestCertificatesCutoff: "Corte para diplomas",
  contestCertificatesCutoffHelp: "O n\u00famero de competidores nas primeiras posi\u00e7\u00f5es a receber diplomas especiais. Os demais competidores receber\u00e3o diplomas de participa\u00e7\u00e3o que n\u00e3o mencionam onde terminaram.",
  contestCertificatesError: "Ocorreu um erro ao gerar os diplomas.",
  contestCertificatesGenerate: "Gerar diplomas",
  contestCertificatesGenerateSuccessfully: "Diplomas gerados com sucesso.",
  contestDetailsGoToContest: "Ir ao concurso",
  contestDownloadListOfUsersInContest: "Fa\u00e7a o download da lista de coders no concurso",
  contestDuration: "Dura\u00e7\u00e3o: %(duration)",
  contestEdit: "Editar",
  contestEditAddProblemSearchByAlias: "Alias",
  contestEditAddProblemSearchByAll: "Tudo",
  contestEditAddProblemSearchById: "Id",
  contestEditAddProblemSearchByTitle: "T\u00edtulo",
  contestEditAddProblems: "Problemas",
  contestEditAdministrativeLinks: "V\u00ednculos administrativos",
  contestEditArchive: "Arquivar",
  contestEditArchiveConfirmText: "Tem certeza que deseja executar esta a\u00e7\u00e3o?",
  contestEditArchiveContest: "Arquivar concurso",
  contestEditArchiveHelpText: "Ao arquivar um concurso, ele n\u00e3o aparecer\u00e1 mais em todas as listas. A \u00fanica forma de acess\u00e1-lo \u00e9 atrav\u00e9s do seu URL ou da lista de \"Meus Concursos que eu administro\", na sec\u00e7\u00e3o \" Concursos arquivados\". Esta a\u00e7\u00e3o pode ser desfeita.",
  contestEditArchivedSuccess: "Concurso arquivado com sucesso.",
  contestEditCannotReplaceTeamsGroupWithSubmissions: "Voc\u00ea n\u00e3o pode substituir o grupo de equipes em um concurso que j\u00e1 tenha solu\u00e7\u00f5es",
  contestEditCatLanguageAddedWarning: "Adicionado \"cat\" aos idiomas do concurso porque o problema adicionado exige",
  contestEditCertificates: "Diplomas",
  contestEditContestClonedSuccessfully: "Seu concurso foi clonado com sucesso",
  contestEditContestEdited: "O concurso foi editado",
  contestEditContestLinkCopiedToClipboard: "Link da competi\u00e7\u00e3o copiado para a \u00e1rea de transfer\u00eancia com sucesso",
  contestEditCopyContestLink: "Copiar link da competi\u00e7\u00e3o",
  contestEditGoToContest: "Exibir concurso",
  contestEditRegisteredAdminDelete: "Remover",
  contestEditRegisteredAdminRole: "Papel",
  contestEditRegisteredAdminUsername: "Coder",
  contestEditRegisteredGroupAdminName: "Grupo",
  contestEditTagDelete: "Remover",
  contestEditTagName: "Nome da etiqueta",
  contestEditTeamsGroupReplace: "Substituir grupo de equipes",
  contestEditTeamsGroupReplaced: "Grupo de equipes substitu\u00eddo com sucesso",
  contestEditUnarchiveContest: "Desarquivar concurso",
  contestEditUnarchiveHelpText: "Este concurso j\u00e1 est\u00e1 arquivado, se desejar devolv\u00ea-lo \u00e0 lista de concursos desarquivados, clique no bot\u00e3o.",
  contestEditUnarchivedSuccess: "Concurso desarquivado com sucesso.",
  contestEditWithTitle: "Editar concurso %(title)",
  contestEndTime: "Termina: %(endDate)",
  contestEnrollStatus: "Inscrito",
  contestFilterBy: "Filtrar por",
  contestFilterByAll: "Tudo",
  contestFilterByRecommended: "Apenas recomendado",
  contestFilterBySignedUp: "Eu sou participante",
  contestForTeamsCanNotChangeToContest: "O concurso para equipes n\u00e3o pode ser alterado para o concurso normal",
  contestGroupAdded: "Grupo adicionado com sucesso",
  contestGroupRemoved: "Grupo removido com sucesso",
  contestInformationNotRequired: "As informa\u00e7\u00f5es sobre a conta para este concurso n\u00e3o foram necess\u00e1rias.",
  contestIntroDifferentStarts: "Uma vez que o concurso come\u00e7ou, sua dura\u00e7\u00e3o ser\u00e1 de %(window_length).",
  contestIntroGoToHomePage: "V\u00e1 para a p\u00e1gina inicial",
  contestIntroLogout: "Sair",
  contestIntroLogoutToJoinWithRegisteredUser: "Pode ser que voc\u00ea tenha recebido o convite para este concurso usando uma conta diferente da que est\u00e1 atualmente conectada. Gostaria de sair e, em seguida, fazer login com as credenciais corretas?",
  contestIntroPenaltyDesc: "Se penalizar\u00e1 con un tiempo de %(window_length) cada env\u00edo incorrecto.",
  contestIntroScoreboardTimePercent: "O painel ao vivo ser\u00e1 mostrado no come\u00e7o e at\u00e9 %(window_length) depois.",
  contestIntroScoreboardTimePercentOneHundred: "O painel ao vivo ser\u00e1 mostrado durante todo o concurso.",
  contestIntroScoreboardTimePercentZero: "O painel n\u00e3o ser\u00e1 mostrado durante o concurso.",
  contestIntroSubmissionsSeparationDesc: "Para cada envio incorreto, voc\u00ea deve aguardar %(window_length) para fazer um novo envio.",
  contestLengthTooLong: "A dura\u00e7\u00e3o do concurso n\u00e3o podem ser maior \u00e1 31 dias.",
  contestListArchivedContests: "Concursos arquivados",
  contestListCurrent: "Atuais",
  contestListEmpty: "N\u00e3o h\u00e1 concursos que atendam a essas caracter\u00edsticas",
  contestListFuture: "Pr\u00f3ximos",
  contestListPast: "Pasados",
  contestListShowAdminContests: "Tamb\u00e9m mostrar concursos que eu gerencio",
  contestListSubmissions: "Solu\u00e7\u00f5es",
  contestMustBeCreatedInPrivateMode: "O concurso deve ser criado no modo privado",
  contestNew: "Novo concurso",
  contestNewForm: "Estilo Preseletivo IOI",
  contestNewFormAdmissionMode: "Modo de acesso",
  contestNewFormAdmissionModeDescription: "Selecione o modo do concurso. Existem tr\u00eas modalidades diferentes:<br /><ul><li>Privado: O concurso s\u00f3 \u00e9 vis\u00edvel para coders que foram explicitamente convidados.</li><li>Registo/aberto: Qualquer pessoa pode registar-se, apenas as pessoas admitidas pelos administradores t\u00eam acesso.</li><li>P\u00fablico: Qualquer pessoa pode participar.</li></ul>",
  contestNewFormBasicInformationRequired: "\u00c9 necess\u00e1ria informa\u00e7\u00e3o b\u00e1sica",
  contestNewFormBasicInformationRequiredDesc: "Se ativado, todos os concorrentes devem ter registrado suas informa\u00e7\u00f5es b\u00e1sicas para participar do concurso (pa\u00eds, estado, escola)",
  contestNewFormByContests: "Em caso de empate, ser\u00e1 quebrado pelo tempo. O tempo ser\u00e1 medido entre o momento em que o concurso come\u00e7ou e o momento em que cada problema foi resolvido.",
  contestNewFormByProblem: "Em caso de empate, ser\u00e1 quebrado pelo tempo. O tempo ser\u00e1 medido entre o momento em que cada problema foi aberto e o momento em que foi resolvido.",
  contestNewFormByRuntime: "Em caso de empate, ser\u00e1 quebrado pelo tempo de execu\u00e7\u00e3o do programa (milissegundos).",
  contestNewFormConacupStyle: "Estilo CONACUP",
  contestNewFormDecrementFactor: "A pontua\u00e7\u00e3o de cada problema ser\u00e1 dada pela f\u00f3rmula: (1 - (%(window_length) + %(window_length) * TT^2 / (10 * PT^2 + TT^2), onde PT \u00e9 a penalidade em minutos do env\u00edo e TT o tempo total do concurso, en minutos.",
  contestNewFormDescription: "Descri\u00e7a\u00f5 de concurso",
  contestNewFormDifferentStarts: "Diferentes in\u00edcios",
  contestNewFormDifferentStartsDesc: "Quando \u00e9 ativado, indica o tempo em minutos que tem o coder para concursar e enviar solu\u00e7\u00f5es a partir do momento em que entra no concurso na plataforma. O valor deve ser inferior \u00e0 diferen\u00e7a em minutos da dura\u00e7\u00e3o do concurso. Se n\u00e3o estiver ativbado, s\u00f3 \u00e9 poss\u00edvel participar entre a hora de in\u00edcio e a hora de fim do concurso.",
  contestNewFormEndDate: "Data de t\u00e9rmino",
  contestNewFormEndDateDesc: "A hora (no hor\u00e1rio local) em que o concurso vai acabar.",
  contestNewFormForTeams: "Concurso para equipes",
  contestNewFormForTeamsDesc: "Se ativado, s\u00f3 pode ser acessado por equipes em vez de identidades. As equipes devem ser adicionadas a um grupo de equipes. Esta op\u00e7\u00e3o est\u00e1 dispon\u00edvel apenas para novos concursos.",
  contestNewFormICPCStyle: "Estilo ICPC",
  contestNewFormImmediateFeedbackDesc: "Depois de avaliar cada envio, o veredicto ser\u00e1 mostrado.",
  contestNewFormImmediateSummaryFeedbackDesc: "Depois de avaliar cada envio, ser\u00e1 mostrado o resumo das pontua\u00e7\u00f5es e veredictos para cada grupo de casos.",
  contestNewFormLanguageRemoveBlockedWarning: "N\u00e3o \u00e9 poss\u00edvel remover \"%(language)\" dos idiomas porque h\u00e1 pelo menos um problema que o exige",
  contestNewFormLanguages: "Definir idiomas para o concurso atual",
  contestNewFormNoPenalty: "Os coders com a mesma pontua\u00e7\u00e3o ficar\u00e3o empatados, independentemente do tempo gasto por cada coder.",
  contestNewFormNumberOfContestants: "Number de competidores",
  contestNewFormNumberOfContestantsDesc: "N\u00famero de competidores permitidos para cada equipe",
  contestNewFormOmiStyle: "Estilo OMI - IOI",
  contestNewFormPenaltyDesc: "N\u00famero de minutos que se penalizam por enviar uma solu\u00e7\u00e3o incorreta.",
  contestNewFormPenaltyType: "Tipo de penaliza\u00e7\u00e3o",
  contestNewFormPenaltyTypeDesc: "Ele indica como penalidade frete \u00e9 calculado: tempo desde que a concurso come\u00e7ou, o tempo j\u00e1 que o problema \u00e9 aberto, ou tempo de execu\u00e7\u00e3o do programa.",
  contestNewFormPointDecrementFactor: "Fator de decrescimiento de pontua\u00e7\u00e3o",
  contestNewFormPointDecrementFactorDesc: "Un n\u00famero entre 0 e 1 inclusive. Si este n\u00famero \u00e9 deferente de zero, a pontua\u00e7\u00e3o que se obtem ao resolver corretamente um problema descresce conforme passa o tiempo. O valor da pontua\u00e7\u00e3o estar\u00e1 dado por (1 - points_decay_factor) + points_decay_factor * TT ^ 2 / (10 * PT ^ 2 + TT ^ 2), onde PT \u00e9 a penalidade em minutos do env\u00edo e TT o tempo total do concurso, en minutos.",
  contestNewFormRecommended: "Concurso recomendado",
  contestNewFormRecommendedTextAdmin: "Ative esta op\u00e7\u00e3o se voc\u00ea deseja que seu concurso apare\u00e7a na lista de Concursos Recomendados.",
  contestNewFormRecommendedTextNonAdmin: "Para mostrar seu concurso na lista de Concursos Recomendados, entre em contato com soporte@omegaup.com.",
  contestNewFormScheduleContest: "Agendar concurso",
  contestNewFormScheduleVirtualContest: "Agendar concurso virtual",
  contestNewFormScoreMode: "Modo de pontua\u00e7\u00e3o",
  contestNewFormScoreModeAllOrNothing: "Tudo ou nada",
  contestNewFormScoreModeDesc: "Escolha \"Tudo ou nada\" se voc\u00ea quiser que os competidores tenham que resolver todos os casos dos problemas para obter pontos. Escolha \"Parcial\" se quiser que os competidores ganhem pontos correspondentes ao envio que resolveu a maioria dos casos de teste. Escolha \"M\u00e1ximo por grupo\" se quiser que os concorrentes obtenham os pontos correspondentes a todos os casos que conseguiram resolver com qualquer um dos seus envios.",
  contestNewFormScoreModeMaxPerGroup: "M\u00e1ximo por grupo",
  contestNewFormScoreModePartial: "Parcial",
  contestNewFormScoreboardAtContestEnd: "O painel pode ser visto no final do concurso",
  contestNewFormScoreboardAtEnd: "Painel de avalia\u00e7\u00e3o no final do concurso",
  contestNewFormScoreboardAtEndDesc: "Mostrar automaticamente o painel de avalia\u00e7\u00e3o completo ao finalizar o concurso.",
  contestNewFormScoreboardTimePercent: "Quanto tempo se mostrar\u00e1 o painel de avalia\u00e7\u00e3o? (%) ",
  contestNewFormScoreboardTimePercentDesc: "N\u00famero entre 0 e 100, indicando a percentagem do tempo que o painel de avalia\u00e7\u00e3o ser\u00e1 vis\u00edvel.",
  contestNewFormShortTitleAlias: "T\u00edtulo curto (alias)",
  contestNewFormShortTitleAliasDesc: "O titulo curto se usa para construir a URL do concurso (exemplos: CodingCup2023, OFMI2024, CopaCentroAmericana2024, etc.). N\u00e3o pode conter espa\u00e7os.",
  contestNewFormStartDate: "Data de in\u00edcio",
  contestNewFormStartDateDesc: "A data (no hor\u00e1rio local), no qual a concurso come\u00e7ar\u00e1",
  contestNewFormSubmissionsSeparation: "Separa\u00e7\u00e3o das Solu\u00e7\u00f5es",
  contestNewFormSubmissionsSeparationDesc: "Tempo m\u00ednimo em minutos que deve esperar un competidor depois de entregar uma solu\u00e7\u00e3o a um problema para poder entregar outra (1 minuto m\u00ednimo).",
  contestNewFormTitlePlaceholderConacupStyle: "**Estilo CONACUP usado. Colocar o seu t\u00edtulo aqui**",
  contestNewFormTitlePlaceholderICPCStyle: "**Estilo ICPC usado. Colocar o seu t\u00edtulo aqui**",
  contestNewFormTitlePlaceholderIoiStyle: "**Estilo IOI usado. Colocar o seu t\u00edtulo aqui**",
  contestNewFormTitlePlaceholderOmiStyle: "**Estilo OMI usado. Colocar o seu t\u00edtulo aqui**",
  contestNewFormUpdateContest: "Atualizar concurso",
  contestNewFormUserInformationRequired: "Solicitar acesso \u00e0s informa\u00e7\u00f5es do participante",
  contestNewFormUserInformationRequiredDesc: "Escolha \"Opcional\" para permitir que cada coder decida se quer partilhar as suas informa\u00e7\u00f5es pessoais e participar de forma independente. Caso contr\u00e1rio, escolha \"Obrigat\u00f3rio\", mas tenha em conta que algumas pessoas podem optar por n\u00e3o participar.",
  contestNewInvalidStartTime: "O tempo de in\u00edcio deve ser antes do tempo do fim",
  contestNotFound: "Concurso n\u00e3o encontrado",
  contestNotRegistered: "Voc\u00ea n\u00e3o est\u00e1 registrado para este concurso.",
  contestNotStarted: "Concurso n\u00e3o tem iniciado",
  contestOrderBy: "Classificar por",
  contestOrderByContestants: "Competidores",
  contestOrderByDuration: "Dura\u00e7\u00e3o",
  contestOrderByEnds: "Finaliza",
  contestOrderByOrganizer: "Organiza\u00e7\u00e3o",
  contestOrderBySignedUp: "Inscrito",
  contestOrderByTitle: "Nome",
  contestParticipant: "Coder",
  contestPracticeMode: "Pr\u00e1tica",
  contestPrintableVersion: "Vers\u00e3o para impress\u00e3o",
  contestPublicForTeamsNotSupported: "Os concursos p\u00fablicos para equipes ainda n\u00e3o s\u00e3o suportados",
  contestPublicRequiresProblem: "Os concursos p\u00fablicos exigem pelo menos um problema. Adicione um problema e, em seguida, marque o concurso como p\u00fablico em Editar Concurso.",
  contestRegistrationPreAcceptedDescription: "Esta conta foi explicitamente convidada para o concurso",
  contestReport: "Relat\u00f3rio do Concurso: %(contest_alias)",
  contestReportProblemWithAlias: "Problema: %(alias)",
  contestReportProblemWithPoints: "Pontos: %(points)",
  contestReportTotalPoints: "Total: %(total_points)",
  contestReportUsername: "Nome da conta: %(username)",
  contestScoreboardAdminLink: "link Admin painel de avalia\u00e7\u00e3o",
  contestScoreboardDownloadCsvFile: "Baixar painel de avalia\u00e7\u00e3o (.csv)",
  contestScoreboardLink: "link painel de avalia\u00e7\u00e3o",
  contestScoreboardMergeChoseContests: "Escolha os concursos",
  contestStartTime: "Inicia: %(startDate)",
  contestStartedTime: "Finalizado: %(startedDate)",
  contestUpdateAlreadyHasRuns: "A dura\u00e7\u00e3o do concurso n\u00e3o pode ser alterada se voc\u00ea j\u00e1 tem solu\u00e7\u00f5es julgadas.",
  contestVirtualMode: "Virtual",
  contestWillBeginIn: "Concurso inciar\u00e1 em %(time)",
  contestsCreate: "Criar Concurso",
  contestsJoinScoreboards: "Juntar Paineis de Avalia\u00e7\u00e3o",
  countryNotSet: "Pa\u00eds n\u00e3o definido",
  courseActionScoreboard: "Painel de avalia\u00e7\u00e3o",
  courseAddContent: "Adicionar conte\u00fado",
  courseAddLecturesAdd: "Adicionar leituras",
  courseAddLecturesAddAssignmentDesc: "Adicione todas as leituras que deseja incluir. Esses leituras ser\u00e3o armazenados ap\u00f3s que voc\u00ea pressione o bot\u00e3o Adicionar conte\u00fado. Se n\u00e3o quiser decidir quais leituras usar agora, voc\u00ea pode adicion\u00e1-las mais tarde.",
  courseAddLecturesAssignmentsDesc: "Escreva o nome da leitura a ser adicionado na conte\u00fado.",
  courseAddLecturesEditAssignmentDesc: "Adicione todos as leituras que deseja incluir. Esses leituras ser\u00e3o armazenados pressionando o bot\u00e3o Adicionar leitura.",
  courseAddProblemsAdd: "Adicionar problemas",
  courseAddProblemsAddAssignmentDesc: "Adicione todos os problemas que deseja incluir. Esses problemas ser\u00e3o armazenados ap\u00f3s que voc\u00ea pressione o bot\u00e3o Adicionar conte\u00fado. Se n\u00e3o quiser decidir quais problemas usar agora, voc\u00ea pode adicion\u00e1-los mais tarde.",
  courseAddProblemsAssignmentsDesc: "Escreva o nome do problema a ser adicionado na conte\u00fado.",
  courseAddProblemsEditAssignmentDesc: "Adicione todos os problemas que deseja incluir. Esses problemas ser\u00e3o armazenados pressionando o bot\u00e3o Adicionar problema.",
  courseArchiveConfirmText: "Tem certeza que deseja executar esta a\u00e7\u00e3o?",
  courseArchiveHelpText: "Ao arquivar um curso, ele n\u00e3o aparecer\u00e1 mais em todas as listas. A \u00fanica forma de acess\u00e1-lo \u00e9 atrav\u00e9s do seu URL ou da lista de \"Cursos que eu administro\", na sec\u00e7\u00e3o \" Cursos arquivados\". Esta a\u00e7\u00e3o pode ser desfeita.",
  courseArchivedSuccess: "Curso arquivado exitosamente.",
  courseAssignmentAdded: "Conte\u00fado adicionada com sucesso!",
  courseAssignmentConfirmDelete: "Voc\u00ea realmente deseja excluir %(assignment)?",
  courseAssignmentDelete: "Excluir conte\u00fado",
  courseAssignmentDeleted: "Conte\u00fado excluida com sucesso!",
  courseAssignmentEdit: "Editar conte\u00fado",
  courseAssignmentEndDateBeforeCourseStartDate: "A data de t\u00e9rmino \u00e9 anterior \u00e0 data de in\u00edcio do curso",
  courseAssignmentLectureAdded: "Leitura adicionada com sucesso.",
  courseAssignmentLectureRemove: "Remover leitura de designa\u00e7\u00e3o",
  courseAssignmentLectureRemoved: "Leitura removida com succeso.",
  courseAssignmentLectureReorder: "Reordenar leituras de designa\u00e7\u00e3o",
  courseAssignmentLecturesEmpty: "N\u00e3o h\u00e1 leituras",
  courseAssignmentNewFormEndDateDesc: "Data (hora local) quando termina.",
  courseAssignmentNewFormSchedule: "Criar conte\u00fado",
  courseAssignmentNewFormShortTitleAliasDesc: "O t\u00edtulo curto \u00e9 usado para construir o URL (exemplo: TAREFA, EXAMEFINAL)",
  courseAssignmentNewFormStartDateDesc: "Hora e data (na hora local) em que vai come\u00e7ar.",
  courseAssignmentNewFormUpdate: "Atualizar conte\u00fado",
  courseAssignmentProblemAdded: "Problema adicionado com sucesso.",
  courseAssignmentProblemConfirmRemove: "Voc\u00ea realmente deseja remover %(problem)?",
  courseAssignmentProblemRemove: "Remover problema de designa\u00e7\u00e3o",
  courseAssignmentProblemRemoved: "Problema removido com succeso.",
  courseAssignmentProblemReorder: "Reordenar problemas de designa\u00e7\u00e3o",
  courseAssignmentProblemRunsEmpty: "No h\u00e1 solu\u00e7\u00f5es",
  courseAssignmentProblemsEmpty: "N\u00e3o h\u00e1 problemas",
  courseAssignmentReorder: "Reordenar cote\u00fado de curso",
  courseAssignmentStartDateBeforeCourseStartDate: "A data de in\u00edcio \u00e9 anterior \u00e0 data de in\u00edcio do curso",
  courseAssignmentTitle: "%(courseName) - %(assignmentName)",
  courseAssignmentUpdated: "Designa\u00e7\u00e3o editada com sucesso!",
  courseBasicInformationNeeded: "Para participar do curso, voc\u00ea deve preencher sua informa\u00e7\u00f5e b\u00e1sica. [V\u00e1 para o meu perfil](/profile/#edit-basic-information).",
  courseCardCourseResume: "Retomar",
  courseCardImpartedBy: "Ministrado por: **%(school_name)**",
  courseCardMustLogIn: "Deve iniciar ses\u00e3o para ver estes cursos.",
  courseCardProgress: "Progresso:",
  courseCardPublicLevelAdvanced: "\u2605\u2605\u2605 Avan\u00e7ado",
  courseCardPublicLevelIntermediate: "\u2605\u2605 Intermedi\u00e1rio",
  courseCardPublicLevelIntroductory: "\u2605 Introduct\u00f3rio",
  courseCardsListSearch: "\ud83d\udd0d Nome do curso",
  courseCloneCreatedBy: "Criado por",
  courseCloneGenerateLinkButton: "Gerar link",
  courseCloneGenerateLinkDescription: "Qualquer pessoa com quem voc\u00ea compartilhar este link pode us\u00e1-lo para clonar o curso por um per\u00edodo de 7 dias",
  courseCloneGenerateLinkSuccess: "O link foi gerado com sucesso",
  courseCloneGenerateLinkTitle: "Gerar link clone",
  courseContentEmpty: "Sem conte\u00fado",
  courseContentNewFormTypeDesc: "O tipo de designa\u00e7\u00e3o \u00e9 usado para distinguir visualmete entre uma tarefa de una li\u00e7\u00e3o ou um exame nos cursos.",
  courseCreate: "Criar Curso",
  courseDetailsOverallCompletedPoints: "%(completed_points) de %(total_points) pontos",
  courseDetailsProgress: "Progresso do curso",
  courseDetailsSettings: "Configura\u00e7\u00f5es",
  courseDetailsTabContent: "Conte\u00fado",
  courseDetailsTabInformation: "Informa\u00e7\u00e3o geral",
  courseDoesNotAdmitRegistration: "Curso n\u00e3o admite cadastro de estudantes",
  courseDoesNotHaveUnlimitedDuration: "N\u00e3o \u00e9 poss\u00edvel definir uma dura\u00e7\u00e3o ilimitada se o curso for de dura\u00e7\u00e3o n\u00e3o ilimitada.",
  courseEdit: "Editar curso",
  courseEditAddAdminsTooltip: "Adicionar administratores usando seu nome de conta omegaUp",
  courseEditAddGroupAdminsTooltip: "Adicionar grupos de administratores. Verifique se o grupo existe.",
  courseEditAddGroupTeachingAssistantTooltip: "Adicione grupos de assistentes de ensino. Verifique se o grupo existe",
  courseEditAddLectures: "Adicionar leituras",
  courseEditAddProblems: "Adicionar problema",
  courseEditAddStudentsAdd: "Adicionar",
  courseEditAddStudentsDescription: "Gerenciar os alunos que participar\u00e3o do curso",
  courseEditAddStudentsStudent: "Estudante",
  courseEditAddTeachingAssistants: "Adicionar assistente de ensino",
  courseEditAddTeachingAssistantsTooltip: "Adicionar assistentes de ensino usando seu nome da conta omegaUp",
  courseEditAdmins: "Admins",
  courseEditAdminsEmpty: "N\u00e3o hay administratores",
  courseEditAdmissionModeDescription: "Manual: Estudantes explicitamente convidados podem inscrever-se.\nCompartilhar URL: Qualquer pessoa com o link pode candidatar-se a inscrever-se. Al\u00e9m disso, pode adicionar manualmente o nome da conta de cada estudante.",
  courseEditAdmissionModeSelect: "Selecione o modo de acesso ao curso",
  courseEditArchive: "Arquivar",
  courseEditClone: "Clone",
  courseEditCourseClonedSuccessfully: "Seu curso foi clonado com sucesso! <a href=\"/course/%(course_alias)/edit/\">Editar curso</a>",
  courseEditCourseEdited: "O curso foi editado",
  courseEditCourseEditedAndGoToCourse: "O curso foi editado! <a href=\"/course/%(alias)\">Ir para curso</a>",
  courseEditGoToCourse: "Ir para curso",
  courseEditGroupAdminsEmpty: "N\u00e3o hay grupos de admins",
  courseEditGroupTeachingAssistant: "Grupo de assistente de ensino",
  courseEditGroupTeachingAssistantAdded: "Grupo de assistentes de ensino adicionado com sucesso",
  courseEditGroupTeachingAssistantRemoved: "Grupo de assistentes de ensino removido com sucesso",
  courseEditGroupTeachingAssistantsEmpty: "N\u00e3o hay grupos de assistentes de ensino",
  courseEditRequestSetRecommendedCourse: "Se voc\u00ea estiver interessado em ter seu curso apare\u00e7a na lista de cursos p\u00fablicos, entre em contato com [hello@omegaup.com](mailto:hello@omegaup.com) indicando o alias do curso para revis\u00e3o.",
  courseEditShowInPublicCoursesList: "Mostrar na lista de cursos p\u00fablicos",
  courseEditStudents: "Alunos",
  courseEditTeachingAssistantAddedSuccessfully: "Assistente de ensino adicionado com sucesso",
  courseEditTeachingAssistantRemovedSuccessfully: "Assistente de ensino removido com sucesso",
  courseEditTeachingAssistants: "Assistente de ensino",
  courseEditTeachingAssistantsEmpty: "N\u00e3o hay assistentes de ensino",
  courseExamEmpty: "N\u00e3o tem provas",
  courseExtraPointsProblem: "V\u00e1lido para pontos extras",
  courseExtraPointsProblemDesc: "Os pontos deste problema s\u00f3 se contam no caso n\u00e3o seja atingida a pontua\u00e7\u00e3o final do curso.",
  courseExtraPointsProblemLabel: "Problema para puntos extra",
  courseGroupNotFound: "Grupo do curso n\u00e3o encontrado",
  courseHomepageStudentsSectionContent: "**Alunos**\n\n- Recebem feedback autom\u00e1tico sobre suas solu\u00e7\u00f5es.\n- Aprendem habilidades que ir\u00e3o servi\\-los na sua vida profissional.\n- Accesam cursos online 24/7.\n",
  courseHomepageTeachersSectionContent: "**Professores**\n\n- Accesam e usam mais de 2.000 problemas de qualidade para usar como tarefas e testes.\n- Observam o progresso dos seus alunos.\n- Identificam os problemas que s\u00e3o dif\u00edceis para seus alunos.\n",
  courseHomepageTitle: "Descobrindo e preparando o talento da Latinoam\u00e9rica",
  courseIntroImpartedBy: "Organizado por",
  courseIntroLevel: "N\u00edvel: %(level)",
  courseIntroWhatYouWillLearn: "O que voc\u00ea aprender\u00e1 neste curso",
  courseInvalidStartTime: "O tempo de in\u00edcio deve ser antes do tempo do fim",
  courseLevelAdvanced: "Avan\u00e7ado",
  courseLevelAdvancedLevel: "N\u00edvel avan\u00e7ado",
  courseLevelAllLevels: "Todos os n\u00edveis",
  courseLevelIntermediate: "Intermedi\u00e1rio",
  courseLevelIntermediateLevel: "N\u00edvel intermedi\u00e1rio",
  courseLevelIntroductory: "Introduct\u00f3rio",
  courseLevelIntroductoryLevel: "N\u00edvel introdut\u00f3rio",
  courseList: "Lista de cursos",
  courseListAdminCourses: "Cursos que eu gerencio",
  courseListArchivedCourses: "Cursos arquivados",
  courseListCurrentCourses: "Cursos atuais",
  courseListPastCourses: "Cursos passados",
  courseListSubmissionsByGroup: "Solu\u00e7\u00f5es feitas por estudantes deste curso",
  courseListTeachingAssistantCourses: "Cursos a los que asisto",
  courseNew: "Novo curso",
  courseNewFormBasicInformationRequired: "\u00c9 necess\u00e1ria informa\u00e7\u00e3o b\u00e1sica",
  courseNewFormBasicInformationRequiredDesc: "Se ativado, todos os concorrentes devem ter registrado suas informa\u00e7\u00f5es b\u00e1sicas para participar do curso (pa\u00eds, estado, escola)",
  courseNewFormDescription: "Descri\u00e7\u00e3o",
  courseNewFormEndDate: "Data de finaliza\u00e7\u00e3o",
  courseNewFormEndDateDesc: "Data e hora (no hor\u00e1rio local), em que o curso vai acabar.",
  courseNewFormLanguages: "Definir idiomas para o curso atual",
  courseNewFormLevel: "N\u00edvel",
  courseNewFormLevelDesc: "O n\u00edvel de dificuldade do curso.",
  courseNewFormObjective: "Objetivo",
  courseNewFormObjectiveDesc: "Descreva o que seus estudantes aprender\u00e3o neste curso.",
  courseNewFormScheduleCourse: "Criar o curso",
  courseNewFormShortTitleAlias: "T\u00edtulo curto (alias)",
  courseNewFormShortTitleAliasDesc: "O alias \u00e9 usado para construir o URL do curso (examples: IPNVERANO2016, ITVERINTRO2016)",
  courseNewFormShowScoreboard: "Mostrar painel de avalia\u00e7\u00e3o",
  courseNewFormShowScoreboardDesc: "Mostre aos alunos o painel de avalia\u00e7\u00e3o geral.",
  courseNewFormStartDate: "Data de in\u00edcio",
  courseNewFormStartDateDesc: "Data e hora (hora local), em que o curso come\u00e7a.",
  courseNewFormUnlimitedDuration: "Dura\u00e7\u00e3o ilimitada",
  courseNewFormUnlimitedDurationDesc: "Se ativada, a data final ser\u00e1 nula e o curso ter\u00e1 dura\u00e7\u00e3o ilimitada.",
  courseNewFormUpdateCourse: "Atualizar curso",
  courseNewFormUserInformationRequired: "Solicitar informa\u00e7\u00f5es do participante",
  courseNewFormUserInformationRequiredDesc: "Ative esta op\u00e7\u00e3o para solicitar acesso \u00e0s informa\u00e7\u00f5es dos participantes que pertencem ao curso para serem contatados mais tarde. Tenha em mente que o participante pode escolher se deseja dar acesso a suas informa\u00e7\u00f5es ou n\u00e3o.",
  courseNotFound: "Curso n\u00e3o encontrado",
  coursePrivacyConsent: "Consentimento de privacidade do curso",
  courseProgressGlobalScore: "Pontua\u00e7\u00e3o global",
  courseRegistrationPreAcceptedDescription: "Esta conta foi explicitamente convidada para o curso",
  courseRequestFeedback: "Voc\u00ea tem d\u00favidas? solicite feedback sobre seu c\u00f3digo!",
  courseStatisticsAverageRuns: "N\u00famero m\u00e9dio de envios",
  courseStatisticsAverageScore: "M\u00e9dia da pontua\u00e7\u00e3o",
  courseStatisticsMaximumScore: "Pontua\u00e7\u00e3o m\u00e1xima",
  courseStatisticsMinimumScore: "Pontua\u00e7\u00e3o m\u00ednima",
  courseStatisticsScoreVariance: "Vari\u00e2ncia de pontua\u00e7\u00e3o",
  courseStatisticsStudentsAbove: "Estudantes com pontua\u00e7\u00e3o maior do que 60%",
  courseStatisticsStudentsCompleted: "Estudentes com pontua\u00e7\u00e3o igual a 100%",
  courseStatisticsStudentsScored: "Estudantes com pontua\u00e7\u00e3o de 0%",
  courseStatisticsVariance: "Vari\u00e2ncia",
  courseStatisticsVerdicts: "Distribui\u00e7\u00e3o dos veredictos",
  courseStudentAdded: "Estudiante adicionado correctamente.",
  courseStudentCountLabel: "Alunos: %(student_count)",
  courseStudentNotInCourse: "O estudante n\u00e3o estava no curso.",
  courseStudentRemoved: "O estudante foi removido com sucesso.",
  courseStudentSelectAssignment: "Selecione designa\u00e7\u00e3o",
  courseStudentSelectStudent: "Selecione o aluno",
  courseStudentsEmpty: "N\u00e3o h\u00e1 alunos",
  courseStudentsProgress: "Progresso do aluno",
  courseStudentsProgressExportToSpreadsheet: "Exportar tabela como:",
  courseSubmissionNotFound: "A submiss\u00e3o para algum problema deste curso n\u00e3o tem sido encontrada.",
  courseSubmissionsList: "Lista de submiss\u00f5es de cursos",
  courseTabEnrolled: "Cursos que estudo (%(course_count))",
  courseTabEnrolledUnlogged: "Cursos que estudo",
  courseTabFinished: "Cursos terminados (%(course_count))",
  courseTabFinishedUnlogged: "Cursos terminados",
  courseTabPublic: "Explorar cursos",
  courseTabsEmptyEnrolledCourses: "Voc\u00ea n\u00e3o est\u00e1 inscrito em cursos nenhum",
  courseTabsEmptyFinishedCourses: "N\u00e3o tem cursos finalizados",
  courseUnarchivedSuccess: "Curso desarquivado exitosamente.",
  courseUpdateAlreadyHasRuns: "A dura\u00e7\u00e3o n\u00e3o pode ser alterada depois que uma solu\u00e7\u00e3o foi avaliada.",
  courseWithoutProblems: "Sem problemas",
  createContestInteractiveGuideContestTitle: "Escolha o t\u00edtulo do seu concurso",
  createContestInteractiveGuideDescription: "Adicione uma descri\u00e7\u00e3o para o seu concurso",
  createContestInteractiveGuideSchedule: "Ap\u00f3s preencher todas as informa\u00e7\u00f5es, agende o concurso",
  createContestInteractiveGuideShortTitle: "Escolha um t\u00edtulo curto para o seu concurso",
  createContestInteractiveGuideStyle: "Escolha entre estilos de concursos predefinidos",
  createContestInteractiveGuideTitle: "Criar um Concurso",
  createContestInteractiveGuideWelcome: "Vamos criar um concurso",
  createCourseInteractiveGuideAskInformation: "Escolha se deseja solicitar informa\u00e7\u00f5es pessoais dos estudantes.",
  createCourseInteractiveGuideBasicInformation: "Escolha se \u00e9 obrigat\u00f3rio para cada estudante compartilhar suas informa\u00e7\u00f5es pessoais.",
  createCourseInteractiveGuideDescription: "Digite uma breve descri\u00e7\u00e3o do curso.",
  createCourseInteractiveGuideDuration: "Voc\u00ea deseja que o curso tenha dura\u00e7\u00e3o ilimitada?",
  createCourseInteractiveGuideEndDate: "Escolha a data de t\u00e9rmino do curso.",
  createCourseInteractiveGuideLanguage: "Selecione as linguagens de programa\u00e7\u00e3o permitidas.",
  createCourseInteractiveGuideLevel: "Selecione o n\u00edvel de dificuldade do curso.",
  createCourseInteractiveGuideName: "Escolha o nome do curso.",
  createCourseInteractiveGuideObjective: "Qual ser\u00e1 o objetivo do curso?",
  createCourseInteractiveGuideSchool: "Digite o nome da sua escola.",
  createCourseInteractiveGuideScoreboard: "Voc\u00ea deseja exibir o placar no curso?",
  createCourseInteractiveGuideShortTitle: "Escolha um alias para o curso.",
  createCourseInteractiveGuideStartDate: "Escolha a data de in\u00edcio do curso.",
  createCourseInteractiveGuideSubmit: "Agendar curso.",
  createCourseInteractiveGuideTitle: "Criar Curso.",
  createCourseInteractiveGuideWelcome: "Bem-vindo, vamos criar um curso.",
  createIdentitiesInteractiveGuideCopy: "Pode copi\u00e1-lo premindo este bot\u00e3o",
  createIdentitiesInteractiveGuideExample: "Aqui est\u00e1 um exemplo de como voc\u00ea deve carregar as identidades no arquivo",
  createIdentitiesInteractiveGuideFormat: "Lembre-se de carreg\u00e1-las no formato CSV",
  createIdentitiesInteractiveGuideInformation: "Lembre-se de ler as informa\u00e7\u00f5es importantes.",
  createIdentitiesInteractiveGuideInformationConfirm: "Ap\u00f3s verificar que tudo est\u00e1 correto, clique no bot\u00e3o 'Criar Identidades'.",
  createIdentitiesInteractiveGuideInformationPassword: "Depois de adicionar o arquivo, revise os registros que foram criados e armazene as senhas geradas em um local seguro, pois elas n\u00e3o ser\u00e3o exibidas novamente.",
  createIdentitiesInteractiveGuidePassword: "Deseja gerar palavras-passe de leitura f\u00e1cil?",
  createIdentitiesInteractiveGuideTitle: "Criar identidades",
  createIdentitiesInteractiveGuideUpload: "Carregue suas identidades. Lembre-se de que deve ser um arquivo no formato CSV.",
  createIdentitiesInteractiveGuideWelcome: "Ol\u00e1, vamos criar identidades!",
  createProblemInteractiveGuideFile: "Carregue o arquivo .zip com as informa\u00e7\u00f5es do problema.",
  createProblemInteractiveGuideOrigin: "Escolha a fonte do problema.",
  createProblemInteractiveGuideProblemTitle: "Escolha o t\u00edtulo do problema.",
  createProblemInteractiveGuideShortTitle: "Escolha um t\u00edtulo curto para o problema.",
  createProblemInteractiveGuideTagsAndLevel: "Escolha as etiquetas e o n\u00edvel do seu problema",
  createProblemInteractiveGuideTitle: "Criar um problema",
  createProblemInteractiveGuideType: "Escolha o tipo de problema.",
  createProblemInteractiveGuideValidator: "Selecione o tipo de validador de sa\u00edda.",
  createProblemInteractiveGuideWelcome: "Bem-vindo, vamos criar um problema.",
  createZipFileForProblem: "Criar um arquivo ZIP para o problema",
  csrfException: "Tentativa de Cross-site Request Forgery",
  currentStatus: "situa\u00e7\u00e3o atual",
  datePickerFormat: "dd/mm/yyyy",
  dateTimePickerFormat: "dd/mm/yyyy hh:ii",
  deleteProblemLevel: "Deletar o n\u00edvel do problema",
  demotionProblemEmailBannedBody: "<p>Prezado <strong>%(user_name)</strong>:</p><p>O acesso ao seu problema <strong>%(problem_name)</strong> no omegaUp foi restrito porque foi relatado como inadequado. A equipe omegaUp analisou este relat\u00f3rio e confirmou que o problema n\u00e3o \u00e9 apropriado porque <em>%(reason)<em>.</p><p>Para desbloquear o problema e exibi-lo novamente na lista de problemas, siga as etapas abaixo:</p><p><ol><li>Revise e edite seu problema: certifique-se de descrever um problema, n\u00e3o \u00e9 ofensivo ou spam.</li><li>Depois de ter resolvido o motivo de por que seu problema foi bloqueado, envie um email <a href=\"mailto:quality@omegaup.com\" target=\"_top\">quality@omegaup.com</a> para ser revisado e reativado.</li></ol></p><p>Se as etapas mencionadas acima n\u00e3o forem seguidas, o problema n\u00e3o ser\u00e1 mostrado novamente na lista de problemas, nem pode ser usado em competi\u00e7\u00f5es. Em caso de reca\u00edda em tr\u00eas ocasi\u00f5es, omegaUp reserva-se o direito de suspender sua conta.</p><p>omegaUp \u00e9 uma plataforma para ajudar as pessoas a melhorar suas habilidades de engenharia de software, resolvendo problemas de c\u00f3digo e competindo em concursos de programa\u00e7\u00e3o. omegaUp congratula-se com todos os problemas que ajudam a atingir esse objetivo.</p><p>Obrigado,</p><p>Equipe omegaUp</p>",
  demotionProblemEmailBannedSubject: "O problema [%(problem_name)] foi relatado como inadequado",
  demotionProblemEmailWarningBody: "<p>Prezado %(user_name):</p><p>O acesso ao seu problema% (problem_name) no omegaup.com foi marcado com um aviso porque foi relatado por outras contas. A equipe omegaUp analisou este relat\u00f3rio e confirmou que o problema tem alguns aspectos que podem ser aprimorados porque %(reason).</p><p>Para remover a notifica\u00e7\u00e3o de aviso do problema e retorn\u00e1-lo ao normal, siga as etapas abaixo:</p><p><ol><li>Revise e edite seu problema.</li><li>Depois de ter resolvido o motivo de por que seu problema foi relatado, envie um email quality@omegaup.com para ser revisado.</li></lo></p><p>Se as etapas mencionadas acima n\u00e3o forem seguidas, o problema mostrar\u00e1 um sinal de aviso na lista de problemas.</p><p>omegaUp \u00e9 uma plataforma para ajudar as pessoas a melhorar suas habilidades de engenharia de software, resolvendo problemas de c\u00f3digo e competindo em concursos de programa\u00e7\u00e3o. omegaUp congratula-se com todos os problemas que ajudam a atingir esse objetivo.</p><p>Obrigado,</p><p>Equipe omegaUp</p>",
  demotionProblemEmailWarningSubject: "O problema [%(problem_name)] foi marcado com um aviso",
  demotionProblemMultipleAnswerNo: "N\u00e3o, apenas este relat\u00f3rio",
  demotionProblemMultipleAnswerYes: "Sim, verifique todas",
  demotionProblemMultipleQuestion: "Deseja fazer isso para todos os relat\u00f3rios deste problema?",
  demotionProblemNotificationBanned: "O problema [%(problem_name)] foi relatado como inadequado. Para mais detalhes, verifique seu e-mail.",
  demotionProblemNotificationWarning: "O problema [%(problem_name)] foi marcado com um aviso. Para mais detalhes, verifique seu e-mail.",
  dependentsBlockedMessage: "Conta bloqueada. Para validar o dependente, \u00e9 necess\u00e1rio entrar em contato com a nossa equipe de suporte.",
  dependentsMessage: "\u00c9 necess\u00e1rio aprovar a conta do seu dependente dentro de %(days) dias. Caso contr\u00e1rio, a conta ser\u00e1 exclu\u00edda.",
  dependentsOneDayUntilVerificationDeadline: "Aten\u00e7\u00e3o! Resta apenas 1 dia para aprovar a conta do seu dependente. Caso contr\u00e1rio, a conta ser\u00e1 exclu\u00edda.",
  dependentsStatus: "Status",
  dependentsTitle: "Acesso dos pais",
  dependentsUser: "Usu\u00e1rio",
  dependentsVerified: "A conta do dependente foi verificada com sucesso",
  downloadZip: "Baixar zip",
  duplicateTagsNotAllowed: "As tags duplicadas n\u00e3o s\u00e3o permitidas. H\u00e1 pelo menos uma tag duplicada na lista: %(tags) <br> Por favor, corrija a informa\u00e7\u00e3o.",
  editFieldRequired: "Um valor necess\u00e1rio est\u00e1 faltando",
  emailNotVerified: "Seu e-mail n\u00e3o est\u00e1 verificado ainda. Por favor veja o e-mail de verifica\u00e7\u00e3o em sua caixa de entrada e spam. Se voc\u00ea ainda tiver problemas, entre em contato soporte@omegaup.com para apoio.",
  enterContest: "Acesse o concurso",
  ephemeralGraderAlert: "Voc\u00ea precisa de uma tela de tamanho maior para usar o Ephemeral Grader. Tente colocar o seu telefone na posi\u00e7\u00e3o horizontal ou use outro dispositivo.",
  errorWhileSendingMail: "Houve um erro ao enviar o e-mail de verifica\u00e7\u00e3o. Por favor, tente novamente mais tarde ou entre em contato soporte@omegaup.com para apoio. Seu e-mail n\u00e3o est\u00e1 verificado ainda.",
  feedbackLeftBy: "%(date), por:",
  feedbackNotSentYet: "Ainda n\u00e3o se tem enviado o feedback para esta submiss\u00e3o.",
  feedbackSuccessfullyAdded: "O feedback tem sido satisfat\u00f3riamente adicionado.",
  feedbackSuccessfullyUpdated: "O feedback tem sido satisfat\u00f3riamente atualizado.",
  feedbackTitle: "Feedback sobre a submiss\u00e3o",
  firstSumbissionWithIdentity: "Tenha em mente que voc\u00ea est\u00e1 tentando enviar uma solu\u00e7\u00e3o com uma conta de identidade",
  fontSize: "Tamanho da Fonte",
  forSelectedItems: "Para os itens selecionados",
  forbiddenInVirtualContest: "Proibido em concurso virtual",
  frontPageDevelopers: "Desenvolvedores",
  frontPageFooter: "aumentando o n\u00famero de engenheiros de software talentosos na am\u00e9rica latina.",
  frontPageFooterAboutUs: "Sobre omegaUp",
  frontPageFooterCodeConduct: "C\u00f3digo de Conduta",
  frontPageFooterContact: "Contate-Nos",
  frontPageFooterCopyright: "Copyright \u00a9 %(currentYear) omegaUp, Inc. Todos os direitos reservados.",
  frontPageFooterHelpUs: "Ajude-nos",
  frontPageFooterOrganization: "Organiza\u00e7\u00e3o",
  frontPageFooterPrivacyPolicy: "Pol\u00edtica de privacidade",
  frontPageFooterSite: "Site",
  frontPageFooterSponsors: "Patrocinador",
  frontPageFooterTeam: "Equipo",
  frontPageNextContests: "Concursos pr\u00f3ximos",
  generalError: "Oops. Eu encontrei um erro interno. Por favor, tente novamente.",
  groupAdminAdded: "Grupo do administradores adicionado com sucesso",
  groupAdminRemoved: "Grupo do administradores removido com sucesso",
  groupCreateIdentities: "Criar identidades",
  groupEditEdit: "Editar",
  groupEditGroupUpdated: "O grupo foi atualizado com sucesso.",
  groupEditMemberAdded: "Membro adicionado com sucesso!",
  groupEditMemberPasswordUpdated: "Senha de identidade atualizada corretamente!",
  groupEditMemberRemoved: "Membro removido com sucesso!",
  groupEditMemberUpdated: "Membro atualizado com sucesso!",
  groupEditMembers: "Membros",
  groupEditMembersAddMembers: "Adicionar membros",
  groupEditMembersChangePassword: "Clique aqui para mudar a senha",
  groupEditMembersCoder: "Coder",
  groupEditMembersEdit: "Clique aqui para editar as informa\u00e7\u00f5es do membro",
  groupEditMembersRemove: "Clique aqui para remover o membro do grupo",
  groupEditMembersTitle: "Adicionar membros para o equipe: %(username)",
  groupEditScoreboards: "Paineis de avalia\u00e7\u00e3o",
  groupEditScoreboardsAdd: "Criar painel de avalia\u00e7\u00e3o",
  groupEditScoreboardsAddContest: "Adicionar concurso",
  groupEditScoreboardsAdded: "Painel adicionado com sucesso!",
  groupEditScoreboardsContestsAdded: "Concurso adicionado com sucesso!",
  groupEditScoreboardsContestsRemoved: "Concurso removido com sucesso!",
  groupEditScoreboardsEdit: "Editar painel de avalia\u00e7\u00e3o %(scoreboard)",
  groupEditTitle: "Editar grupo",
  groupEditTitleWithName: "Editar grupo %(name)",
  groupIdentitiesNotRequiredPrivileges: "Voc\u00ea n\u00e3o tem as permiss\u00f5es necess\u00e1rias para criar identidades. Para obt\u00ea-las, envie um email para *[soporte@omegaup.com](mailto:soporte@omegaup.com?subject=Solicita\u00e7\u00e3o%20de%20Acesso%20para%20Cria\u00e7\u00e3o%20de%20Identidades)* com o assunto \"Solicita\u00e7\u00e3o de Acesso para Cria\u00e7\u00e3o de Identidades\" e inclua os seguintes detalhes:\n\n- Nome do concurso\n- Institui\u00e7\u00e3o organizadora\n- Nome do contato na institui\u00e7\u00e3o organizadora\n- Nome de usu\u00e1rio do contato no omegaUp\n- N\u00famero aproximado de concorrentes\n- Data do concurso\n\nSe o seu concurso come\u00e7ar em menos de 48 horas, inclua a palavra **\"URGENTE\"** no assunto do seu email.",
  groupMemberUsernameInUse: "H\u00e1 pelo menos um nome de conta duplicado nas identidades do grupo: <br> %(usernames) <br> Corrija as informa\u00e7\u00f5es.",
  groupModalBack: "Voltar",
  groupModalSave: "Salvar",
  groupNewFormCreateGroup: "Criar grupo",
  groupNewFormDescription: "Descri\u00e7\u00e3o do Grupo",
  groupNewFormOnlyAC: "Contar s\u00f3 ACs",
  groupNewFormUpdateGroup: "Salvar altera\u00e7\u00f5es",
  groupNewFormWeight: "Peso do pontua\u00e7\u00e3o",
  groupNotFound: "Grupo n\u00e3o encontrado",
  groupScoreboardDetailsCoder: "Coder",
  groupsCanNotBeAddedInContestForTeams: "Os grupos n\u00e3o podem ser adicionados em concursos para equipes",
  groupsCreateNew: "Novo grupo",
  groupsCsvHelp: "<p>Adicione rapidamente v\u00e1rias identidades a este grupo. As identidades n\u00e3o s\u00e3o contas normais e n\u00e3o precisam ter um email ou validar sua conta.</p>\n<p>As identidades devem estar em um arquivo <code>.csv</code> com o seguinte formato:\n<samp><pre>username,name,country_id,state_id,gender,school_name\nusername-1,Developer Diana,MX,AGU,female,Best School\nusername-2,Danny Dev,MX,AGU,male,Best School</pre></samp></p>",
  groupsIdentitiesSuccessfullyCreated: "As identidades foram criadas e ligadas ao grupo.",
  groupsIdentityWarning: "Salve as senhas em um local seguro, porque depois de criar as identidades, n\u00e3o haver\u00e1 maneira de recuperar as senhas.",
  groupsInvalidCsv: "Fa\u00e7a o upload de um arquivo CSV v\u00e1lido.",
  groupsUploadCsvFile: "Subir CSV arquivo",
  homepageCompeteSectionDescription: "Participe de concursos de programa\u00e7\u00e3o e teste seus conhecimentos",
  homepageCompeteSectionTitle: "Compita",
  homepageCreateSectionDescription: "Organize seu concurso com problemas dispon\u00edveis na plataforma ou crie seus pr\u00f3prios problemas",
  homepageCreateSectionTitle: "Crie",
  homepageSponsorsSectionTitle: "Obrigado ao nosso Patrocinador",
  homepageTeachSectionDescription: "Acompanhe o progresso do seu aluno atrav\u00e9s de tarefas e testes que s\u00e3o avaliados automaticamente",
  homepageTeachSectionTitle: "Ensine",
  homepageTrainSectionDescription: "Resolva problemas e melhore suas habilidades",
  homepageTrainSectionTitle: "Treine",
  identityAlreadyAssociated: "Voc\u00ea j\u00e1 tem uma identidade associada ao mesmo grupo.",
  identityAlreadyInUse: "A identidade j\u00e1 \u00e9 usada por outra conta.",
  identityInGroup: "A identidade j\u00e1 est\u00e1 associada ao grupo",
  incompatibleArgs: "Argumentos n\u00e3o podem ser definidos simultaneamente",
  interactiveGuideDoneButton: "Feito",
  interactiveGuideNextButton: "Seguinte",
  interactiveGuidePreviousButton: "Anterior",
  invalidLanguage: "Idioma inv\u00e1lido",
  invalidParameters: "Par\u00e2metros inv\u00e1lidos.",
  invalidResetToken: "Token inv\u00e1lido.",
  invalidScoreboardUrl: "Url do painel de avalia\u00e7\u00e3o inv\u00e1lido.",
  invalidStatementType: "Tipo de elabora\u00e7\u00e3o inv\u00e1lido",
  invalidUser: "Nome de conta inv\u00e1lido.",
  invalidVisibility: "O par\u00e2metro de visibilidade pode ser um dos seguintes valores: deleted, private_banned, public_banned, private_warning, private, public_warning, public e promoted",
  joinCourseInteractiveGuideJoin: "Clique no bot\u00e3o de in\u00edcio para se juntar ao curso.",
  joinCourseInteractiveGuideSearch: "Aqui voc\u00ea pode buscar cursos por nome.",
  joinCourseInteractiveGuideTabs: "Navegue entre cursos que concluiu, explore novos cursos e ver os cursos que est\u00e1 cursando",
  joinCourseInteractiveGuideTitle: "Unir-se a um curso",
  joinCourseInteractiveGuideWelcome: "Ol\u00e1! Aqui voc\u00ea pode encontrar seus cursos.",
  lastUpdate: "\u00daltima atualiza\u00e7\u00e3o",
  levelTagHelp: "Os n\u00edveis devem coincidir com a carreira escolar do aluno e andar de m\u00e3os dadas com os cursos que eles costumam fazer.",
  libinteractiveDownload: "Baixar",
  libinteractiveFilename: "Arquivo que voc\u00ea deve enviar",
  libinteractiveIdlFilename: "Nome de arquivo .idl",
  libinteractiveIdlFilenameHelp: "O nome do arquivo .idl (sem a extens\u00e3o). Deve ter entre 1 e 32 caracteres alfanum\u00e9ricos.",
  libinteractiveLanguage: "Idioma",
  libinteractiveOs: "Sistema Operacional",
  libinteractiveTitle: "Modelo para problemas interativos",
  liveStatistics: "Estat\u00edsticas ao vivo",
  locale: "pt",
  lockdown: "Opera\u00e7\u00e3o n\u00e3o permitida no modo lockdown",
  lockdownDetailsDisabled: "A visualiza\u00e7\u00e3o do c\u00f3digo-fonte foi desativada temporariamente.",
  lockdownMessageWarning: "Aviso: no modo lockdown, Suas env\u00edos n\u00e3o ser\u00e3o mais acess\u00edveis se voc\u00ea sair da p\u00e1gina.",
  loginAccountName: "Nome da conta",
  loginDateOfBirth: "Data de nascimento",
  loginDisabled: "A sua conta est\u00e1 inativa h\u00e1 muito tempo e foi desactivada para sua seguran\u00e7a. Entre em contato com soporte@omegaup.com para acessar novamente.",
  loginEmail: "Endere\u00e7o de E-mail",
  loginEmailUsername: "E-mail ou usu\u00e1rio",
  loginFacebookEmptyEmailError: "Um endere\u00e7o de e-mail \u00e9 necess\u00e1rio para utilizar omegaUp. Por favor, proporcione acesso ao e-mail de Facebook para continuar",
  loginFederated: "Conta em outros sites",
  loginGoogleInvalidCSRFToken: "Token CSRF inv\u00e1lido",
  loginHeader: "Entrar em omegaUp",
  loginLogIn: "Entrar",
  loginNative: "Conta omegaUp",
  loginParentEmail: "E-mail de figura parental",
  loginPassword: "Senha",
  loginPasswordCreate: "Senha (no m\u00ednimo 8 caracteres)",
  loginPasswordTooShort: "Senha \u00e9 muito curta",
  loginRecover: "Esqueceu sua senha?",
  loginRepeatPassword: "Repetir senha",
  loginRequired: "Voc\u00ea precisa fazer o login para executar essa a\u00e7\u00e3o",
  loginSignUp: "Registrar",
  loginSignupHeader: "Criar uma conta omegaUp, r\u00e1pido e f\u00e1cil!",
  loginThroughThirdParty: "Sua conta foi criada atrav\u00e9s de um login externo (Google, Facebook, etc.). Por favor, fa\u00e7a login usando esse mecanismo novamente para definir uma senha.",
  logoutConfirmationTitle: "Confirmar logout",
  mailFromUserLikelyRemoved: "Este correo j\u00e1 est\u00e1 em uso. Provavelmente, foi utilizado, mas a conta foi removida. Se deseja usar este e-mail, entre em contato com soporte@omegaup.com para obter suporte.",
  mailInUse: "Este e-mail j\u00e1 est\u00e1 em uso. Tente novamente.",
  makePrivate: "Tornar privado",
  makePublic: "Tornar p\u00fablico",
  makeRegistration: "Tornar aberto com registro",
  matrixEditTitle: "Editor de matriz",
  matrixModalBack: "Voltar",
  matrixModalColumns: "Colunas",
  matrixModalDistinct: "Distinto",
  matrixModalDistinctAll: "Todos",
  matrixModalDistinctColumn: "Coluna",
  matrixModalDistinctHeader: "Selecionar tipo distinto",
  matrixModalDistinctNone: "Nenhum",
  matrixModalDistinctRow: "Linha",
  matrixModalGenerate: "Gerar",
  matrixModalGeneratedArray: "Matriz gerada",
  matrixModalMaximum: "M\u00e1ximo",
  matrixModalMinimum: "M\u00ednimo",
  matrixModalRows: "Linhas",
  matrixModalSave: "Salvar",
  messageMakeYourContestsPublic: "Voc\u00ea tem concursos privados que j\u00e1 terminaram. Por favor, considere torn\u00e1-los p\u00fablicos para contribuir para a comunidade.",
  messageMakeYourProblemsPublic: "Voc\u00ea tem problemas privados que j\u00e1 foram utilizados. Por favor, considere torn\u00e1-los p\u00fablicos para contribuir para a comunidade.",
  modalConsentCookiesAccept: "Aceite todos os cookies",
  modalConsentCookiesDecline: "Aceite apenas cookies essenciais",
  modalConsentCookiesDescription: "Usamos cookies para garantir que voc\u00ea tenha a melhor experi\u00eancia em nosso site.",
  mustLoginToFilterUsers: "Voc\u00ea deve entrar para filtrar coders no ranking.",
  mustLoginToJoinContest: "Voc\u00ea deve entrar na sua conta para se inscrever num concurso",
  mustRegisterToJoinContest: "voc\u00ea deve se registrar para entrar concurso",
  mustRegisterToJoinCourse: "voc\u00ea deve se registrar para entrar curso",
  mustUpdateBasicInfoToFilterUsers: "N\u00e3o \u00e9 poss\u00edvel utilizar os filtros de classifica\u00e7\u00e3o se as informa\u00e7\u00f5es do seu perfil n\u00e3o estiverem completas.",
  myproblemsListCreateProblem: "Criar Problema",
  myproblemsListCreateProblemWithExistingZipFile: "Eu tenho um arquivo zip",
  myproblemsListCreateZipFileProblem: "Criar arquivo zip",
  myproblemsListMyProblems: "Meus Problemas",
  navAlgorithmsBook: "Livro tutorial \"Problemas y Algoritmos\" de Luis Vargas",
  navAllCourses: "Todos os cursos",
  navAllProblems: "Todos os problemas",
  navAuthorRanking: "Ranking de contribuidores",
  navBlog: "Blog",
  navCoderOfTheMonth: "Coder do m\u00eas geral",
  navCoderOfTheMonthFemale: "Coder do m\u00eas para eles",
  navContests: "Concursos",
  navContestsEnrolled: "Concursos inscrito",
  navCourses: "Cursos",
  navCoursesEnrolled: "Cursos inscrito",
  navDependents: "Meus dependentes",
  navDiscord: "Servidor de Discord",
  navHelp: "Ajuda",
  navLogIn: "Entrar / Inscrever-se",
  navMyContent: "Meu conte\u00fado",
  navMyContests: "Meus concursos",
  navMyCourses: "Meus cursos",
  navMyGroups: "Meus grupos",
  navMyProblems: "Meus problemas",
  navMyQualityNomination: "Meus relat\u00f3rios de problemas",
  navMyTeamsGroups: "Meus grupos de equipes",
  navProblems: "Problemas",
  navProfileProblems: "Problemas resolvidos e tentados",
  navQualityNominationQueue: "Relat\u00f3rios",
  navRanking: "Ranking",
  navSchoolOfTheMonth: "Escola do m\u00eas",
  navSchoolRanking: "Ranking de escolas",
  navTutorials: "Tutoriais",
  navUserRanking: "Ranking de coders",
  navViewBadges: "Ver crach\u00e1s",
  navViewContests: "Ver Concursos",
  navViewCourses: "Ver Cursos",
  navViewLatestSubmissions: "Ver \u00daltimos Env\u00edos",
  navViewProblems: "Procurar Problemas",
  navViewProblemsAll: "Lista de Problemas",
  navViewProfile: "Meu perfil",
  newPublicTagsNotAllowed: "N\u00e3o \u00e9 permitido adicionar novos tags p\u00fablicos",
  noCoders: "Nenhum programador.",
  nominationsRangeHeader: "Relat\u00f3rios de problemas (de %(lowCount) a %(highCount))",
  notProblemLevelTag: "O tag enviado n\u00e3o \u00e9 um tag de n\u00edvel.",
  notificationContestClarificationRequest: "Uma nova clarifica\u00e7\u00e3o tem sido solicitada para o problema %(problemAlias) do concurso %(contestAlias), que voc\u00ea administra.",
  notificationContestClarificationResponse: "Seu pedido de clarifica\u00e7\u00e3o para o problema %(problemAlias) do concurso %(contestAlias), tem sido respondido.",
  notificationContestRegisterRequest: "%(username) solicitou registro para o concurso %(contestTitle) que voc\u00ea gerencia.",
  notificationContestRegisterationAccepted: "Sua solicita\u00e7\u00e3o de inscri\u00e7\u00e3o para o concurso %(contestTitle) foi **aceita**.",
  notificationContestRegisterationRejected: "Sua solicita\u00e7\u00e3o de inscri\u00e7\u00e3o para o concurso %(contestTitle) foi **rejeitada**.",
  notificationCourseAddAdmin: "Voc\u00ea foi convidado para ser um administrador do curso %(courseName).",
  notificationCourseAddTeachingAssistant: "Voc\u00ea foi convidado para ser um assistente de ensino para o curso %(courseName).",
  notificationCourseAssignmentAdded: "Novo conte\u00fado foi adicionado ao curso %(courseName).",
  notificationCourseAssignmentProblemAdded: "Um novo problema foi adicionado a um exerc\u00edcio em %(courseName).",
  notificationCourseClarificationRequest: "Uma nova clarifica\u00e7\u00e3o tem sido solicitada para o problema %(problemAlias) do curso %(courseName), que voc\u00ea administra.",
  notificationCourseClarificationResponse: "Seu pedido de clarifica\u00e7\u00e3o para o problema %(problemAlias) do curso %(courseName), tem sido respondido.",
  notificationCourseRegistrationAccepted: "Seu pedido de registro no curso %(courseName), tem sido **aceitado**.",
  notificationCourseRegistrationManual: "Voc\u00ea foi convidado para participar do curso %(courseName).",
  notificationCourseRegistrationRejected: "Seu pedido de registro no curso %(courseName), tem sido **rejeitado**.",
  notificationCourseRegistrationRequest: "**%(username)** tem solicitado acceso ao curso %(courseName).",
  notificationCourseRequestFeedback: "**%(username)** tem solicitado feedback sobre a tarefa ***%(assignmentName)*** do curso ***%(courseName)***",
  notificationCourseSubmissionFeedback: "O feedback sobre sua submis\u00e3o para o problema ***%(problemAlias)*** no curso ***%(courseName)*** tem sido submetida.",
  notificationCourseSubmissionFeedbackThread: "**%(username)** respondeu em um feedback sobre seu envio para o problema ***%(problemAlias)*** no curso ***%(courseName)***",
  notificationNewBadge: "Voc\u00ea tem recebido um novo distintivo: **%(badgeName)**",
  notificationNewContestCertificate: "Parab\u00e9ns! Voc\u00ea recebeu um diploma por sua conquista recente no concurso \"%(contest_title)\". Clique para baix\u00e1-lo.",
  notificationNotFound: "Notifica\u00e7\u00e3o n\u00e3o encontrada",
  notificationsMarkAllAsRead: "Marcar tudo como lido",
  notificationsNoNewNotifications: "N\u00e3o h\u00e1 novas notifica\u00e7\u00f5es.",
  officialSolutionsInfo: "Como funciona a solu\u00e7\u00e3o de problemas?",
  omegaUpTitleMyDependents: "Meus dependentes",
  omegaupTitleAdminUsers: "Gerenciamento de coders",
  omegaupTitleAuthorsRank: "Ranking de contribuidores",
  omegaupTitleBadges: "Crach\u00e1s",
  omegaupTitleCertificate: "Diplomas",
  omegaupTitleCertificateValidation: "Verificar diploma",
  omegaupTitleCodersofthemonth: "Programador do m\u00eas",
  omegaupTitleCodersofthemonthFemale: "Programador do m\u00eas feminino",
  omegaupTitleCollections: "Cole\u00e7\u00f5es",
  omegaupTitleCollectionsByAuthor: "Cole\u00e7\u00f5es por autor",
  omegaupTitleCollectionsByLevel: "Cole\u00e7\u00f5es por n\u00edvel",
  omegaupTitleCommonIndex: "Bem-vindo",
  omegaupTitleContest: "Concurso",
  omegaupTitleContestAddAdmin: "Admins",
  omegaupTitleContestEdit: "Editar concurso",
  omegaupTitleContestList: "Lista do concursos",
  omegaupTitleContestNew: "Novo concurso",
  omegaupTitleContestPractice: "Concurso (Modo pratica)",
  omegaupTitleContestPrint: "Concurso (Modo de impress\u00e3o) - %(contestTitle)",
  omegaupTitleContestReport: "Relat\u00f3rio para concurso: %(contestName)",
  omegaupTitleContestScoreboard: "Painel total do concurso",
  omegaupTitleContestStats: "Estat\u00edsticas da concurso",
  omegaupTitleCourseClarifications: "Clarifica\u00e7\u00f5es do curso",
  omegaupTitleCourseDetails: "Detalhes do curso",
  omegaupTitleCourseEdit: "Edigar curso",
  omegaupTitleCourseIntro: "Acesse o curso",
  omegaupTitleCourseNew: "Novo curso",
  omegaupTitleCourseScoreboard: "Painel total do curso",
  omegaupTitleCourseStatistics: "Estat\u00edsticas do curso",
  omegaupTitleCourses: "Cursos",
  omegaupTitleDocs: "\u00cdndice de Documenta\u00e7\u00e3o",
  omegaupTitleGroupScoreboardDetails: "Detalhes do painel de pontua\u00e7\u00e3o do grupo",
  omegaupTitleGroups: "Grupos",
  omegaupTitleGroupsEdit: "Editar grupo",
  omegaupTitleGroupsNew: "Novo grupo",
  omegaupTitleGroupsScoreboardEdit: "Editar painel de avalia\u00e7\u00e3o",
  omegaupTitleLatestSubmissions: "\u00daltimas submiss\u00f5es",
  omegaupTitleLibInteractive: "libinteractive",
  omegaupTitleLogin: "Entrar",
  omegaupTitleLogout: "Sair",
  omegaupTitleMyCertificates: "Meus diplomas",
  omegaupTitleMyContests: "Meus concursos",
  omegaupTitleMyProblemsList: "Meus problemas",
  omegaupTitleParentalVerificationToken: "Token de verifica\u00e7\u00e3o dos pais",
  omegaupTitlePrivacyPolicy: "Pol\u00edtica de privacidade",
  omegaupTitleProblem: "Problema",
  omegaupTitleProblemCreator: "Criador de problemas",
  omegaupTitleProblemEdit: "Ajustes de problema",
  omegaupTitleProblemNew: "Novo problema",
  omegaupTitleProblemPrint: "Problema (Modo de impress\u00e3o) - %(problemTitle)",
  omegaupTitleProblemStats: "Estat\u00edsticas do problema",
  omegaupTitleProblems: "Problemas",
  omegaupTitleProfile: "Perfil",
  omegaupTitleQualityNominationDetails: "Detalhes do problema relatado",
  omegaupTitleQualityNominationList: "Lista de relat\u00f3rios de problemas",
  omegaupTitleQualityNominationMyList: "Minha lista de relat\u00f3rios de problemas",
  omegaupTitleRecoverPassword: "Recupere sua senha",
  omegaupTitleSchoolOfTheMonth: "Escolas do M\u00eas",
  omegaupTitleSchoolProfile: "Perfil de Escola",
  omegaupTitleSchoolsRank: "Ranking de escolas",
  omegaupTitleScoreboardmerge: "Uni\u00e3o de paineis de avalia\u00e7\u00e3o",
  omegaupTitleStatementEditor: "Editor de reda\u00e7\u00e3oes",
  omegaupTitleStudentsProgress: "Progresso dos alunos",
  omegaupTitleSupportDashboard: "Painel de Suporte",
  omegaupTitleTeamsGroupEdit: "Editar grupo de equipes",
  omegaupTitleTeamsGroupNew: "Novo grupo de equipes",
  omegaupTitleTeamsGroups: "Grupos de equipes",
  omegaupTitleUpdatePrivileges: "Atualizar privil\u00e9gios",
  omegaupTitleUsersEditEmail: "Editar e-mail",
  omegaupTitleUsersRank: "Ranking de coders",
  onlyDemotionsSupported: "Resolu\u00e7\u00e3o suportada apenas para demotions para agora.",
  openInKarelJs: "Voc\u00ea pode usar karel.js para resolver este problema",
  originalContestHasNotEnded: "O concurso original ainda n\u00e3o terminou",
  outputOnly: "Somente sa\u00edda",
  outputOnlyDownloadInput: "Baixar .zip com casos de entrada",
  outputOnlyFiles: "Apenas arquivos de sa\u00edda",
  over13yearsOld: "Tenho mais de 13 anos.",
  parameterDateTooLarge: "Data \u00e9 maior que a data m\u00e1xima de %(upper_bound!timestamp)",
  parameterDateTooSmall: "Data \u00e9 menor que a data m\u00ednima de %(lower_bound!timestamp)",
  parameterEmpty: "Par\u00e2metro vazio",
  parameterInvalid: "Par\u00e2metro inv\u00e1lido",
  parameterInvalidAlias: "Par\u00e2metros s\u00f3 podem conter letras, d\u00edgitos, e _. Espa\u00e7os n\u00e3o s\u00e3o permitidos",
  parameterInvalidGroupAlias: "Par\u00e2metro inv\u00e1lido: grupo. Esse grupo n\u00e3o existe, crie-o em https://omegaup.com/group/new/",
  parameterInvalidStateDoesNotBelongToCountry: "O estado selecionado n\u00e3o pertence ao pa\u00eds baseado em ISO 3166-2.",
  parameterInvalidStateNeedsToBelongToCountry: "Voc\u00ea precisa selecionar o pa\u00eds para selecionar um estado.",
  parameterNotADate: "Par\u00e2metro deve ser uma data",
  parameterNotANumber: "Par\u00e2metro deve ser um n\u00famero",
  parameterNotFound: "Valor do par\u00e2metro n\u00e3o encontrado",
  parameterNotInExpectedSet: "Valor n\u00e3o est\u00e1 em conjunto esperado",
  parameterNumberTooLarge: "Valor \u00e9 maior que o valor m\u00e1ximo de %(upper_bound)",
  parameterNumberTooSmall: "Valor \u00e9 menor que o valor m\u00ednimo de %(lower_bound)",
  parameterStringTooLong: "Par\u00e2metro \u00e9 maior de %(max_length) caracteres",
  parameterStringTooShort: "Par\u00e2metro \u00e9 mais curto que *(MIN_LENGTH) caracteres",
  parameterUsernameInUse: "O nome da conta n\u00e3o est\u00e1 dispon\u00edvel",
  parentEmailBody: "Insira este token para vincular a conta do seu filho %(omegaup_url)/user/parentalverification/token/%(parental_verification_token)/",
  parentEmailSubject: "Token gerado",
  parentalTokenNotFound: "Token parental n\u00e3o encontrado",
  parentalTokenVerified: "O token foi verificado com sucesso.",
  passwordAddRequestSuccess: "Sua senha foi adicionada.",
  passwordCopyToken: "C\u00f3pia token",
  passwordGenerateToken: "Gerar token",
  passwordGenerateTokenDesc: "Clique no bot\u00e3o \"Gerar token\" para criar o link",
  passwordHumanReadable: "Incluir senhas de f\u00e1cil leitura",
  passwordMismatch: "Passwords incompat\u00edveis.",
  passwordResetLinkCopiedToClipboard: "O link foi copiado para a prancheta",
  passwordResetMinWait: "Voc\u00ea deve esperar alguns minutos antes de outro pedido.",
  passwordResetPassword: "Nova sehna",
  passwordResetPasswordConfirmation: "Confirma\u00e7\u00e3o de nova senha",
  passwordResetRequestSuccess: "Instru\u00e7\u00f5es foram enviadas para o seu e-mail.",
  passwordResetRequestTitle: "Esqueci minha senha",
  passwordResetResetExpired: "O tempo para redefinir sua senha expirou.",
  passwordResetResetSuccess: "Sua senha foi atualizada.",
  passwordResetResetTitle: "Password Reset",
  passwordResetTokenWasGeneratedSuccessfully: "O token foi gerado com sucesso",
  pendingRegistrations: "Solicita\u00e7\u00f5es pendentes",
  pendingRegistrationsShowAll: "Mostrar todas as solicita\u00e7\u00f5es",
  privacyPolicyNotAccepted: "Por favor leia e aceite a Pol\u00edtica de Uso e Privacidade do site, bem como o C\u00f3digo de Conduta.",
  privacyStatementNotFound: "Declara\u00e7\u00e3o de privacidade n\u00e3o encontrada.",
  privateTagsPlaceholder: "Ex. faculdade, 2019, aulas-2020",
  problemAliasExists: "J\u00e1 existe este alias de problema. Por favor, tente um diferente.",
  problemCollectionAuthors: "Autores",
  problemCollectionBackCollections: "\u25c4 Voltar para cole\u00e7\u00f5es",
  problemCollectionEducationLevel: "Por n\u00edvel educacional",
  problemCollectionOthers: "Outras cole\u00e7\u00f5es",
  problemCollectionProblemCount: "%(count) problemas",
  problemCollectionRandomKarelProblem: "Problema aleat\u00f3rio de Karel",
  problemCollectionRandomLanguageProblem: "problema aleat\u00f3rio",
  problemCollectionSearchProblem: "Localizador de Problemas",
  problemCraetorGroupDownloadIn: "Salvar .in",
  problemCraetorGroupDownloadTxt: "Salvar .txt",
  problemCreatorAdd: "Adicionar",
  problemCreatorAddLine: "Adicionar linha",
  problemCreatorAutomaticPoints: "Pontua\u00e7\u00e3o autom\u00e1tica",
  problemCreatorAutomaticPointsHelperCase: "O programa calcular\u00e1 o valor deste caso usando esta f\u00f3rmula: (pontua\u00e7\u00e3o do grupo - (soma dos casos dentro do grupo que t\u00eam uma pontua\u00e7\u00e3o expl\u00edcita)) / (n\u00famero de casos dentro do grupo sem uma pontua\u00e7\u00e3o expl\u00edcita)",
  problemCreatorAutomaticPointsHelperGroup: "O programa calcular\u00e1 o valor deste grupo usando esta f\u00f3rmula: (100 - (soma dos grupos que t\u00eam uma pontua\u00e7\u00e3o expl\u00edcita) / (n\u00famero de grupos sem uma pontua\u00e7\u00e3o expl\u00edcita))",
  problemCreatorAutomaticPointsRecommended: "Pontua\u00e7\u00e3o autom\u00e1tica (recomendado)",
  problemCreatorCannotHaveSameName: "Voc\u00ea n\u00e3o pode ter dois casos/grupos com o mesmo nome",
  problemCreatorCase: "Caso",
  problemCreatorCaseDownloadIn: "Baixar .in",
  problemCreatorCaseDownloadTxt: "Baixar .txt",
  problemCreatorCaseGroupNameHelper: "Min\u00fasculas e sem espa\u00e7os",
  problemCreatorCaseName: "Nome do caso",
  problemCreatorCasesTabIntroAddPanelIntro: "Este painel permite adicionar um novo caso de teste.",
  problemCreatorCasesTabIntroAddPanelTitle: "Painel de adicionar caso",
  problemCreatorCasesTabIntroSidebarIntro: "Use esta barra lateral para gerenciar seus casos de teste.",
  problemCreatorCasesTabIntroSidebarTitle: "Barra lateral de casos de teste",
  problemCreatorCode: "C\u00f3digo",
  problemCreatorCodeSave: "Salvar",
  problemCreatorCodeTabIntroSaveCodeIntro: "Quando terminar, clique aqui para salvar suas altera\u00e7\u00f5es.",
  problemCreatorCodeTabIntroSaveCodeTitle: "Salvar c\u00f3digo",
  problemCreatorCodeTabIntroSelectLanguageIntro: "Escolha a linguagem de programa\u00e7\u00e3o para o seu c\u00f3digo aqui.",
  problemCreatorCodeTabIntroSelectLanguageTitle: "Selecione uma linguagem",
  problemCreatorCodeTabIntroUploadFileIntro: "Voc\u00ea pode enviar um arquivo com seu c\u00f3digo em vez de digit\u00e1-lo.",
  problemCreatorCodeTabIntroUploadFileTitle: "Enviar arquivo",
  problemCreatorCodeTabIntroWriteCodeIntro: "Use o editor de c\u00f3digo para escrever ou modificar sua solu\u00e7\u00e3o.",
  problemCreatorCodeTabIntroWriteCodeTitle: "Escreva o c\u00f3digo",
  problemCreatorCodeUpload: "Ou fa\u00e7a upload de um arquivo",
  problemCreatorCodeUploadFilesize: "O limite para upload de arquivos s\u00e3o %(limit)",
  problemCreatorContentPlaceHolder: "Conte\u00fado",
  problemCreatorCreateNewProblem: "Criar novo problema",
  problemCreatorCreateNewProblemBack: "Voltar",
  problemCreatorCreateNewProblemContinue: "Continuar",
  problemCreatorCreateNewProblemWarning: "Deseja come\u00e7ar novamente? Todos os dados anteriores ser\u00e3o perdidos e o criador ser\u00e1 reiniciado. Salve o progresso atual antes de criar um novo. Para isso, clique no bot\u00e3o \"Gerar problema\".",
  problemCreatorDeleteCase: "Excluir caso",
  problemCreatorDeleteCases: "Excluir casos",
  problemCreatorDeleteGroup: "Excluir grupo",
  problemCreatorEditCase: "Editar caso",
  problemCreatorEmpty: "",
  problemCreatorEraseOutput: "Limpar sa\u00edda",
  problemCreatorGenerateProblem: "Gerar Problema",
  problemCreatorGroup: "Grupo",
  problemCreatorGroupName: "Nome do grupo",
  problemCreatorGroups: "Grupos",
  problemCreatorIntroCreateIntro: "Use este bot\u00e3o para come\u00e7ar do zero e criar um novo problema.",
  problemCreatorIntroCreateTitle: "Criar novo problema",
  problemCreatorIntroDownloadIntro: "Clique aqui para baixar seu problema como um arquivo .zip quando estiver pronto.",
  problemCreatorIntroDownloadTitle: "Baixar problema",
  problemCreatorIntroLoadIntro: "Clique aqui para enviar um arquivo .zip e carregar um problema existente.",
  problemCreatorIntroLoadTitle: "Carregar problema",
  problemCreatorIntroNameIntro: "Aqui voc\u00ea pode digitar ou editar o nome do seu problema.",
  problemCreatorIntroNameTitle: "Nome do problema",
  problemCreatorIntroReadyIntro: "\u00c9 isso! Agora voc\u00ea est\u00e1 pronto para come\u00e7ar a criar problemas. \ud83c\udf89",
  problemCreatorIntroReadyTitle: "Pronto para criar!",
  problemCreatorIntroWelcomeIntro: "Bem-vindo ao Criador de Problemas! Este guia ir\u00e1 mostrar as principais funcionalidades da interface.",
  problemCreatorIntroWelcomeTitle: "Bem-vindo",
  problemCreatorIntroWorkspaceIntro: "Esta se\u00e7\u00e3o \u00e9 sua \u00e1rea de trabalho para construir um problema. Inclui abas para escrever o enunciado, adicionar c\u00f3digo de solu\u00e7\u00e3o, casos de teste e uma solu\u00e7\u00e3o oficial.",
  problemCreatorIntroWorkspaceTitle: "\u00c1rea de trabalho",
  problemCreatorLabelPlaceHolder: "Etiqueta",
  problemCreatorLayoutAddFromCase: "Adicionar layout do caso selecionado",
  problemCreatorLayoutAddLineInfo: "Agregar informaci\u00f3n de la l\u00ednea",
  problemCreatorLayoutAddNew: "Adicionar novo layout",
  problemCreatorLayoutBarClose: "Fechar barra de layout",
  problemCreatorLayoutCopy: "Hacer una copia",
  problemCreatorLayoutDelete: "Deletar o layout",
  problemCreatorLayoutLoadToAll: "Cargar en todos los casos",
  problemCreatorLayoutLoadToSelected: "Cargar en el caso seleccionado",
  problemCreatorLayoutNew: "Novo layout",
  problemCreatorLayoutWordCopy: " c\u00f3pia",
  problemCreatorLayoutWordLayouts: "layouts",
  problemCreatorLineArray: "Array",
  problemCreatorLineDelete: "Excluir",
  problemCreatorLineEdit: "Editar",
  problemCreatorLineLine: "Linha \u00danica",
  problemCreatorLineMatrix: "Matriz",
  problemCreatorLineMultiline: "Multilinhas",
  problemCreatorLinesDelete: "Excluir linhas",
  problemCreatorLinesReorder: "Reordenar",
  problemCreatorLoadProblem: "Problema de carga",
  problemCreatorMarkdownPreviewInitialRender: "# Pr\u00e9-visualiza\u00e7\u00e3o\n",
  problemCreatorMarkdownSave: "Salvar",
  problemCreatorMultipleCases: "M\u00faltiplos casos",
  problemCreatorName: "Nome",
  problemCreatorNewProblem: "Novo Problema",
  problemCreatorNoGroup: "Nenhum grupo",
  problemCreatorNumberOfCases: "N\u00famero de casos",
  problemCreatorNumberOfCasesHelper: "Os casos ter\u00e3o o nome:",
  problemCreatorOutputPlaceHolder: "Sa\u00edda",
  problemCreatorPoints: "Pontua\u00e7\u00e3o",
  problemCreatorPointsAbbreviation: "pts",
  problemCreatorPrefix: "Prefixo",
  problemCreatorRenameLayout: "Modal de Renomear",
  problemCreatorRenameModalBack: "Voltar",
  problemCreatorRenameModalRename: "Renomear",
  problemCreatorRenameModalTitle: "Modal de Renomear",
  problemCreatorSolution: "Solu\u00e7\u00e3o",
  problemCreatorSolutionTabIntroEditorIntro: "Escreva sua solu\u00e7\u00e3o aqui usando a sintaxe Markdown.",
  problemCreatorSolutionTabIntroEditorTitle: "Editor Markdown",
  problemCreatorSolutionTabIntroPreviewIntro: "Esta se\u00e7\u00e3o mostra uma pr\u00e9-visualiza\u00e7\u00e3o ao vivo da sua solu\u00e7\u00e3o.",
  problemCreatorSolutionTabIntroPreviewTitle: "Pr\u00e9-visualiza\u00e7\u00e3o ao vivo",
  problemCreatorSolutionTabIntroSaveIntro: "Clique neste bot\u00e3o para salvar o conte\u00fado da sua solu\u00e7\u00e3o.",
  problemCreatorSolutionTabIntroSaveTitle: "Salvar solu\u00e7\u00e3o",
  problemCreatorSolutionTabIntroToolbarIntro: "Use esses bot\u00f5es para formatar sua solu\u00e7\u00e3o em Markdown.",
  problemCreatorSolutionTabIntroToolbarTitle: "Barra de ferramentas Markdown",
  problemCreatorStatement: "Esbo\u00e7o",
  problemCreatorSuffix: "Sufixo",
  problemCreatorTestCases: "Casos de teste",
  problemCreatorTitle: "Criador de problemas",
  problemCreatorUngrouped: "Sem_grupo",
  problemCreatorUngroupedCases: "Casos sem grupo",
  problemCreatorUpdateAlert: "O problema foi atualizado com \u00eaxito.",
  problemCreatorUploadZip: "Enviar",
  problemCreatorUploadZipMessage: "Envie aqui o arquivo zip do seu problema.",
  problemCreatorValidatePoints: "Validar e corrigir pontos",
  problemCreatorValidatePointsBack: "Voltar",
  problemCreatorValidatePointsButton: "Validar pontos",
  problemCreatorValidatePointsContinue: "Continuar",
  problemCreatorValidatePointsWarning: "Os pontos de um grupo devem ser iguais \u00e0 soma dos pontos dos casos nele. Por favor, continue validando e corrigindo a distribui\u00e7\u00e3o de pontos em todos os grupos.",
  problemCreatorZipFileIsNotComplete: "O arquivo zip deve conter o arquivo cdp.data",
  problemCreatorZipFileIsNotValid: "O arquivo enviado n\u00e3o \u00e9 um arquivo zip v\u00e1lido",
  problemCreatorZipFileUpload: "Enviar arquivo zip",
  problemDeployerChangeMissingSettingsJson: "O problema precisa ter um arquivo 'settings.json'.",
  problemDeployerConfigBadLayout: "O commit para 'refs/meta/config' tem uma estrutura incorreta.",
  problemDeployerConfigInvalidPublishingMode: "O modo de publica\u00e7\u00e3o escolhido n\u00e3o \u00e9 suportado.",
  problemDeployerConfigRepositoryNotAbsoluteUrl: "O reposit\u00f3rio a ser publicado n\u00e3o \u00e9 um URL absoluto.",
  problemDeployerConfigSubdirectoryMissingTarget: "O reposit\u00f3rio a ser publicado n\u00e3o tem um destino no 'target'.",
  problemDeployerEsNoStatement: "Nenhuma reda\u00e7\u00e3o em espanhol encontrada.",
  problemDeployerExceededZipSizeLimit: "Tamanho do .zip extra\u00eddo (%(size) MiB) supera o m\u00e1ximo permitido (%(max_size) MiB). Rejeitando.",
  problemDeployerFailed: "N\u00e3o foi poss\u00edvel implementar problema",
  problemDeployerInteractiveBadLayout: "O problema interativo n\u00e3o possui a estrutura esperada.",
  problemDeployerInternalError: "Ocorreu um problema interno ao tentar atualizar o problema.",
  problemDeployerInternalGitError: "Ocorreu um problema com o git interno ao tentar atualizar o problema.",
  problemDeployerInvalidZipFilename: "O caminho para o arquivo .zip n\u00e3o \u00e9 v\u00e1lido.",
  problemDeployerJsonParseError: "Ocorreu um problema ao ler o arquivo JSON.",
  problemDeployerLibinteractiveValidationError: "Problema interativo \u00e9 inv\u00e1lido",
  problemDeployerMismatchedInputFile: "Houve pelo menos um arquivo .in sem o correspondente .out.",
  problemDeployerNoStatements: "Nenhuma reda\u00e7\u00e3o encontrada",
  problemDeployerNotAReview: "A fus\u00e3o com o ramo 'master' foi tentada com um compromisso que n\u00e3o \u00e9 uma revista.",
  problemDeployerOmegaupUpdateProblemOldVersion: "O problema est\u00e1 sendo migrado para uma nova vers\u00e3o. Por favor, tente novamente mais tarde.",
  problemDeployerProblemBadLayout: "O problema tem uma estrutura inv\u00e1lida.",
  problemDeployerPublishedMustPointToCommitInMaster: "A atualiza\u00e7\u00e3o para o ramo 'publicado' conta para apontar para um commit no ramo 'master'.",
  problemDeployerReviewBadLayout: "La estructura de la revisi\u00f3n es inv\u00e1lida.",
  problemDeployerSlowRejected: "Problema seria executado por mais de 5 minutos no caso de TLE. Rejeitado.",
  problemDeployerTestsBadLayout: "O formato do diret\u00f3rio tests/ n\u00e3o \u00e9 v\u00e1lido.",
  problemDeployerTooManyObjectsInPackfile: "Hay demasiados objetos en el packfile.",
  problemDeprecated: "Problema \u00e9 obsoleto",
  problemDetailsSource: "Fonte: %(source)",
  problemDownloadZip: "Baixar o arquivo zip para o problema",
  problemEditAccess: "Acesso (opcional)",
  problemEditAddAdmin: "Admins",
  problemEditAddTags: "Etiquetas",
  problemEditBasicInfo: "Informa\u00e7\u00e3o b\u00e1sica",
  problemEditChooseVersion: "Ver hist\u00f3rico de vers\u00f5es",
  problemEditCommitMessage: "Descri\u00e7\u00e3o da altera\u00e7\u00e3o",
  problemEditDeleteCancel: "Cancelar",
  problemEditDeleteConfirmationMessage: "Tem certeza de que deseja excluir o problema?",
  problemEditDeleteOk: "Excluir",
  problemEditDeleteRequireConfirmation: "Exclir problema %(problemAlias)",
  problemEditDeleteSelectedProblemsConfirmationMessage: "Tem certeza de que deseja excluir os problemas selecionados?",
  problemEditDeleteSelectedProblemsRequireConfirmation: "Excluir problemas selecionados",
  problemEditEditMarkdown: "Editar reda\u00e7\u00e3o",
  problemEditEditProblem: "Ajustes de problema",
  problemEditEmailClarifications: "Receba perguntas sobre o problema por e-mail",
  problemEditEvaluation: "Avalia\u00e7\u00e3o (opcional)",
  problemEditFormAllowUserAddTags: "Mostrar as tags sugeridas pelos coders para este problema",
  problemEditFormAppearsAsPublic: "O problema ser\u00e1 acess\u00edvel ao p\u00fablico?",
  problemEditFormCreateProblem: "Criar problema",
  problemEditFormCustom: "Validador Personalizado (validador.$lang$)",
  problemEditFormFile: "Anexar arquivo zip",
  problemEditFormFirstTimeCreatingAProblem: "\u00e9 a primeira vez que voc\u00ea cria um problema?",
  problemEditFormHereIsHowToWriteProblems: "aqui \u00e9 como escrever o arquivo",
  problemEditFormInputLimit: "Tamanho l\u00edmite de entrada (bytes)",
  problemEditFormLanguages: "Tipo de problema",
  problemEditFormLiteral: "Interpretar stdout como pontua\u00e7\u00e3o",
  problemEditFormMemoryLimit: "L\u00edmite de memoria (KiB)",
  problemEditFormNumericTokensWithTolerance: "Tokens num\u00e9rico com toler\u00e2ncia de 1e-9",
  problemEditFormOutputLimit: "Tamanho l\u00edmite de sa\u00edda (bytes)",
  problemEditFormTimeLimit: "Tempo l\u00edmite por caso (ms)",
  problemEditFormTokenByToken: "Token por Token",
  problemEditFormTokenCaseless: "Token por Token, ignorando mai\u00fasculas/min\u00fasculas",
  problemEditFormUpdateMarkdown: "Atualizar reda\u00e7\u00e3o",
  problemEditFormUpdateProblem: "Atualizar problema",
  problemEditFormUpdateSolution: "Atualizar solu\u00e7\u00e3o",
  problemEditFormValidatorTimeLimit: "Tempo l\u00edmite para el validador (ms)",
  problemEditFormValidatorType: "Tipo de validador de sa\u00edda",
  problemEditFormWallTimeLimit: "Tempo l\u00edmite total (ms) (m\u00e1ximo 60000 ms)",
  problemEditGoToProblem: "Ir para o problema",
  problemEditGroupScorePolicy: "Pontua\u00e7\u00e3o do grupos",
  problemEditGroupScorePolicyMin: "M\u00ednimo",
  problemEditGroupScorePolicySumIfNotZero: "Soma (se todos os casos forem diferentes de zero)",
  problemEditLimits: "Limites (opcional)",
  problemEditSolution: "Editar Solu\u00e7\u00e3o",
  problemEditSource: "Fonte do problema",
  problemEditTagPublicRequired: "\u00c9 obrigat\u00f3rio selecionar pelo menos uma etiqueta p\u00fablica e um n\u00edvel do problema",
  problemEditTags: "R\u00f3tulos",
  problemEditUpdatedSuccessfully: "Problema atualizado com sucesso!",
  problemEditValidation: "Valida\u00e7\u00e3o)",
  problemHasBeenUsedInContestOrCourse: "O problema n\u00e3o pode ser exclu\u00eddo, porque ele foi usado em um concurso ou um curso",
  problemIsBanned: "Este problema foi banido.",
  problemIsNotPublic: "O problema n\u00e3o \u00e9 p\u00fablico e est\u00e1 atualmente em pelo menos um concurso em progresso.",
  problemIsPrivate: "Problema \u00e9 marcado como privado.",
  problemLevelAdvancedCompetitiveProgramming: "N\u00edvel Avan\u00e7ado: programa\u00e7\u00e3o competitiva",
  problemLevelAdvancedSpecializedTopics: "N\u00edvel Avan\u00e7ado: t\u00f3picos especializados",
  problemLevelBasicIntroductionToProgramming: "N\u00edvel Fundamental: Introdu\u00e7\u00e3o \u00e0 Programa\u00e7\u00e3o",
  problemLevelBasicKarel: "N\u00edvel Elementar: Karel",
  problemLevelIntermediateAnalysisAndDesignOfAlgorithms: "N\u00edvel Intermedi\u00e1rio: an\u00e1lise e design de algoritmos",
  problemLevelIntermediateDataStructuresAndAlgorithms: "N\u00edvel Intermedi\u00e1rio: estruturas de dados e algoritmos",
  problemLevelIntermediateMathsInProgramming: "N\u00edvel Intermedi\u00e1rio: Matem\u00e1tica em programa\u00e7\u00e3o",
  problemLevelUpdated: "O n\u00edvel do problema foi atualizado.",
  problemListShowAdminProblems: "Tamb\u00e9m mostrar problemas que eu gerencio",
  problemListShowAdminProblemsAndDeleted: "Tamb\u00e9m mostrar problemas que eu gerencio e problemas eliminados",
  problemNew: "Criar problema",
  problemNotFound: "Problema n\u00e3o encontrado",
  problemNotFoundInContest: "Problema n\u00e3o encontrado neste concurso",
  problemNotFoundInProblemset: "Problema n\u00e3o encontrado neste conjunto do problemas",
  problemNotPartOfAssignment: "O problema n\u00e3o faz parte do conte\u00fado.",
  problemPrintableVersion: "Obter a vers\u00e3o imprim\u00edvel do problema",
  problemRestrictedTagInteractive: "Interativo",
  problemRestrictedTagKarel: "Karel",
  problemRestrictedTagLanguage: "Linguagem",
  problemRestrictedTagNoSubmissions: "Leitura (Sem submiss\u00f5es)",
  problemRestrictedTagOnlyOutput: "Somente sa\u00edda",
  problemSettingsSummaryTitleWithLetter: "%(letter). %(problem_title)",
  problemSettingsSummaryTitleWithProblemId: "%(problem_id). %(problem_title)",
  problemSettingsSummaryTitleWithProblemsetTitleAndLetter: "%(problemset_title) - %(letter). %(problem_title)",
  problemSolutionNotVisible: "Voc\u00ea n\u00e3o tem permiss\u00e3o para visualizar a solu\u00e7\u00e3o do problema. Tente resolver o problema primeiro.",
  problemSuccessfullyAdded: "Problema adicionado com sucesso",
  problemSuccessfullyRemoved: "Problema removido com sucesso",
  problemSuccessfullyUpdated: "Problema atualizado com sucesso",
  problemTagAnalysisOfRecurrences: "An\u00e1lise de recorr\u00eancias",
  problemTagAnalyticGeometry: "Geometria anal\u00edtica",
  problemTagArithmetic: "Aritm\u00e9tica",
  problemTagArrays: "Arrays",
  problemTagBOI: "BOI",
  problemTagBacktracking: "Backtracking",
  problemTagBigData: "Big data",
  problemTagBigNumbers: "Numeros grandes",
  problemTagBinarySearch: "Busca bin\u00e1ria",
  problemTagBinarySearchTree: "\u00c1rvore de busca bin\u00e1ria",
  problemTagBipartiteMatching: "Correspond\u00eancia bipartida",
  problemTagBitManipulation: "Manipula\u00e7\u00e3o de bits",
  problemTagBooleanAlgebra: "\u00c1lgebra booleana",
  problemTagBreadthFirstSearch: "Busca em largura",
  problemTagBruteForce: "For\u00e7a bruta",
  problemTagCIIC: "CIIC",
  problemTagCOCI: "COCI",
  problemTagCharsAndStrings: "Caracteres e strings",
  problemTagChineseRemainderTheorem: "Teorema do restante chin\u00eas",
  problemTagCodingCup: "CodingCup",
  problemTagCodingRush: "CodingRush",
  problemTagCombinations: "Combina\u00e7\u00f5es",
  problemTagCombinatorialDesigns: "Design combinacional",
  problemTagConditionals: "Condicionais",
  problemTagConvexHull: "Casco convexo",
  problemTagCountingProblems: "Problemas de contagem",
  problemTagDataCompression: "Compress\u00e3o de dados",
  problemTagDepthFirstSearch: "Busca em profundidade",
  problemTagDiophantineEquations: "Equa\u00e7\u00f5es diofantinas",
  problemTagDirectedGraphs: "Gr\u00e1ficos direcionados",
  problemTagDisjointSets: "Conjuntos disjuntos",
  problemTagDivideAndConquer: "Dividir e conquistar",
  problemTagDivisibilityRules: "Regras de divisibilidade",
  problemTagDynamicProgramming: "Programa\u00e7ao dinamica",
  problemTagExponentialSearch: "Busca exponencial",
  problemTagExponentiationBySquaring: "Exponencia\u00e7\u00e3o bin\u00e1ria",
  problemTagFenwickTrees: "\u00c1rvores Fenwick",
  problemTagFileSeeking: "Posicionamento em arquivos",
  problemTagFormattedInputAndOutput: "Input e output formatados",
  problemTagFourierTransformation: "Transforma\u00e7\u00e3o de Fourier",
  problemTagFunctions: "Fun\u00e7\u00f5es",
  problemTagGCDAndLCM: "M\u00faltiplos e fatores comuns",
  problemTagGameTheory: "Teoria de jogos",
  problemTagGeneticAlgorithms: "Algor\u00edtmos gen\u00e9ticos",
  problemTagGraphConnectivity: "Conectividade em grafos",
  problemTagGraphRepresentation: "Representa\u00e7\u00e3o de grafos",
  problemTagGraphsWithNegativeWeights: "Gr\u00e1ficos com pesos negativos",
  problemTagGreedyAlgorithms: "Algoritmos gulosos",
  problemTagHashing: "Dispers\u00e3o",
  problemTagHeaps: "Mont\u00f5es",
  problemTagHeuristics: "Heur\u00edsticas",
  problemTagICPC: "ICPC",
  problemTagIOI: "IOI",
  problemTagImplementation: "Implementa\u00e7\u00e3o",
  problemTagIncrementalSearch: "Pesquisa incremental",
  problemTagInputAndOutput: "Entrada e sa\u00edda",
  problemTagInvertedIndices: "\u00cdndices invertidos",
  problemTagLazyPropagation: "Propaga\u00e7\u00e3o pregui\u00e7osa",
  problemTagLeastCommonAncestor: "Menos ancestral comum",
  problemTagLexingAndParsing: "An\u00e1lise l\u00e9xica-sint\u00e1tica",
  problemTagLinearSearch: "Busca linear",
  problemTagLinkedLists: "Listas vinculadas",
  problemTagLocalSearch: "Busca local",
  problemTagLoops: "Rota\u00e7\u00f5es",
  problemTagMapsMultimaps: "Mapas e multimapas",
  problemTagMatrices: "Matrizes",
  problemTagMaxFlow: "Pico de fluxo",
  problemTagMeetInTheMiddle: "Meet in the middle",
  problemTagMemorization: "Memoriza\u00e7\u00e3o",
  problemTagMinimumSpanningTrees: "\u00c1rvores de abrang\u00eancia m\u00ednimas",
  problemTagModularArithmetic: "Aritm\u00e9tica modular",
  problemTagModularMultiplicativeInverse: "Inverso modular",
  problemTagMonotoneStack: "Pilha mon\u00f3tona",
  problemTagNearestNeighbors: "Vizinhos mais pr\u00f3ximos",
  problemTagNumberTheory: "Teoria dos N\u00fameros",
  problemTagNumericalMethods: "M\u00e9todos num\u00e9ricos",
  problemTagNumericalSeries: "S\u00e9ries num\u00e9ricas",
  problemTagOFMI: "OFMI",
  problemTagOMI: "OMI",
  problemTagOMIAguascalientes: "OMI Aguascalientes",
  problemTagOMIBajaCalifornia: "OMI Baja California",
  problemTagOMIBajaCaliforniaSur: "OMI Baja California Sur",
  problemTagOMICampeche: "OMI Campeche",
  problemTagOMIChiapas: "OMI Chiapas",
  problemTagOMIChihuahua: "OMI Chihuahua",
  problemTagOMICoahuila: "OMI Coahuila",
  problemTagOMIColima: "OMI Colima",
  problemTagOMIDistritoFederal: "OMI Distrito Federal",
  problemTagOMIDurango: "OMI Durango",
  problemTagOMIGuanajuato: "OMI Guanajuato",
  problemTagOMIGuerrero: "OMI Guerrero",
  problemTagOMIHidalgo: "OMI Hidalgo",
  problemTagOMIJalisco: "OMI Jalisco",
  problemTagOMIMexico: "OMI M\u00e9xico",
  problemTagOMIMichoacan: "OMI Michoac\u00e1n",
  problemTagOMIMorelos: "OMI Morelos",
  problemTagOMINayarit: "OMI Nayarit",
  problemTagOMINuevoLeon: "OMI Nuevo Le\u00f3n",
  problemTagOMIOaxaca: "OMI Oaxaca",
  problemTagOMIPS: "OMIPS",
  problemTagOMIPuebla: "OMI Puebla",
  problemTagOMIQueretaro: "OMI Quer\u00e9taro",
  problemTagOMIQuintanaRoo: "OMI Quintana Roo",
  problemTagOMISanLuisPotosi: "OMI San Luis Potos\u00ed",
  problemTagOMISinaloa: "OMI Sinaloa",
  problemTagOMISonora: "OMI Sonora",
  problemTagOMITabasco: "OMI Tabasco",
  problemTagOMITamaulipas: "OMI Tamaulipas",
  problemTagOMITlaxcala: "OMI Tlaxcala",
  problemTagOMIVeracruz: "OMI Veracruz",
  problemTagOMIYucatan: "OMI Yucat\u00e1n",
  problemTagOMIZacatecas: "OMI Zacatecas",
  problemTagOfflineQueries: "Offline queries",
  problemTagPalindromeAlgorithms: "Algoritmos Palindrome",
  problemTagPartialSums: "Somas parciais",
  problemTagParticleSwarmOptimization: "Otimiza\u00e7\u00e3o de part\u00edculas",
  problemTagPermutations: "Permuta\u00e7\u00f5es",
  problemTagPrimalityTest: "Teste de primazia",
  problemTagPrimeFactorization: "Fatora\u00e7\u00e3o prim\u00e1ria",
  problemTagPrimeGeneration: "Gera\u00e7\u00e3o Prime",
  problemTagProbabilityAndStatistics: "Probabilidade e estat\u00edstica",
  problemTagQueues: "Filas",
  problemTagRecursion: "Recurs\u00e3o",
  problemTagSQRTDecomposition: "Decomposi\u00e7\u00e3o SQRT",
  problemTagSegmentTrees: "\u00c1rvore de segmentos",
  problemTagSetsMultisets: "Conjuntos e multiconjuntos",
  problemTagShortestPaths: "Caminhos mais curtos",
  problemTagSimulation: "Simula\u00e7\u00e3o",
  problemTagSlidingWindow: "Sliding window",
  problemTagSorting: "Ordena\u00e7\u00e3o",
  problemTagStacks: "Pilhas",
  problemTagStringMatching: "Casamento de cadeias",
  problemTagSubArraySearch: "Busca de subarreglos",
  problemTagSubsequenceSearch: "Busca de subsequ\u00eancias",
  problemTagSuffixTrees: "Sufixo \u00e1rvores",
  problemTagSweepLine: "Varredura de avi\u00e3o",
  problemTagSystemsOfEquations: "Sistemas de equa\u00e7\u00f5es",
  problemTagTopologicalSorting: "Ordena\u00e7\u00e3o topol\u00f3gico",
  problemTagTreeTransversal: "Passeios em \u00e1rvores",
  problemTagTrees: "\u00c1rvores",
  problemTagTries: "Tries",
  problemTagTwoPointersTechnique: "T\u00e9cnica de dois ponteiros",
  problemTagUnformattedInputAndOutput: "Entrada e sa\u00edda n\u00e3o formatada",
  problemTagWaveletTrees: "\u00c1rvores Wavelet",
  problemTitleExists: "J\u00e1 existe este t\u00edtulo de problema. Por favor, tente um diferente.",
  problemVersionCurrentVersion: "Versi\u00e3o atual",
  problemVersionDate: "Data de commit",
  problemVersionDiffMode: "Mostrar diff",
  problemVersionDiffModeFiles: "Arquivos",
  problemVersionDiffModeNone: "Ninguno",
  problemVersionDiffModeSubmissions: "Env\u00edos",
  problemVersionMessage: "Mensagem de commit",
  problemVersionNewVersion: "Nova versi\u00e3o",
  problemVersionNotFound: "Vers\u00e3o do problema n\u00e3o encontrada.",
  problemVersionPublishedRevision: "Publicada",
  problemVersionShowOnlyChanges: "Somente Mostrar mudan\u00e7as",
  problemVersionUpdate: "Mudar vers\u00e3o do problema",
  problemVersionUpdatePublishedEditableProblemsets: "Atualizar os concursos / tarefas / exames atualmente em execu\u00e7\u00e3o que gerencio",
  problemVersionUpdatePublishedNonProblemset: "N\u00e3o atualize concursos / tarefas / exames",
  problemVersionUpdatePublishedOwnedProblemsets: "Atualize os concursos / tarefas / exames atualmente em execu\u00e7\u00e3o que possuo",
  problemVersionUpdated: "Vers\u00e3o do problema atualizada.",
  problemVersionUsername: "Nome da conta",
  problemVersionVersion: "Vers\u00e3o do problema",
  problemcollectionViewProblems: "Ver problemas",
  problemlessGrader: "omegaUp IDE",
  problemsOrderUpdated: "A ordem dos problemas foi atualizada.",
  problemsetIdentityNotFound: "A conta ou identidade n\u00e3o est\u00e1 associada ao curso, concurso ou tarefa.",
  problemsetNotFound: "Conjunto de problemas n\u00e3o encontrado.",
  profile: "Nome",
  profileAddIdentitiesTooltip: "Adicionar identidades usando seu nome da conta omegaUp",
  profileApiTokensEmpty: "Sem tokens de API",
  profileAuthorRank: "Classifica\u00e7\u00e3o de autor",
  profileBasicInformation: "Informa\u00e7\u00e3o b\u00e1sica",
  profileContests: "Resultados dos concursos",
  profileContestsTableContest: "Concurso",
  profileContestsTablePlace: "Lugar",
  profileCountry: "Pa\u00eds / Regi\u00e3o",
  profileCreatedContent: "Conte\u00fado criado",
  profileCreatedContentSeeAll: "Ver tudo",
  profileCreatedContests: "Concursos criados",
  profileCreatedCourses: "Cursos criados",
  profileCreatedProblems: "Problemas criados",
  profileEdit: "Editar perfil",
  profileEmail: "E-mail",
  profileGraduationDate: "Data de forma\u00e7\u00e3o",
  profileIdentitiesEmpty: "N\u00e3o h\u00e1 identidades",
  profileIdentityAdded: "Identidade adicionada com sucesso",
  profileManageApiTokens: "Gerenciar chaves de API",
  profileManageIdentities: "Gerenciar identidades",
  profileName: "Nome",
  profileOrganizedContests: "Concursos gerenciados",
  profilePersonalData: "Dados pessoais",
  profilePrivateRankMessage: "Ao ativar esta op\u00e7\u00e3o, a classifica\u00e7\u00e3o da sua conta n\u00e3o ficar\u00e1 vis\u00edvel.",
  profilePrivateRankMessageTitle: "Aviso",
  profileRank: "Classifica\u00e7\u00e3o do coder",
  profileRankBeginner: "\u03bf",
  profileRankExpert: "\u0398",
  profileRankInternationalMaster: "\u03c9",
  profileRankMaster: "\u03a9",
  profileRankSpecialist: "\u039f",
  profileRankUnrated: "Sem classifica\u00e7\u00e3o",
  profileSchool: "Escola",
  profileSchoolMonthlySolvedProblemsCount: "Total de problemas resolvidos pelos coders da escola %(school)",
  profileSolvedProblems: "Problemas resolvidos",
  profileState: "Estado",
  profileStatistics: "Estat\u00edsticas",
  profileStatisticsCumulative: "Cumulativo",
  profileStatisticsDay: "Dia",
  profileStatisticsDelta: "Delta",
  profileStatisticsMonth: "M\u00eas",
  profileStatisticsNumberOfSolvedProblems: "N\u00famero de problemas resolvidos",
  profileStatisticsPeriod: "Per\u00edodo",
  profileStatisticsRuns: "<b>Execu\u00e7\u00f5es</b>",
  profileStatisticsTotal: "Total",
  profileStatisticsVerdictsOf: "Veredictos de %(user)",
  profileStatisticsWeek: "Semana",
  profileStatisticsYear: "Ano",
  profileUnsolvedProblems: "Problemas tentados (mas n\u00e3o resolvidos)",
  profileUsername: "Nome da conta",
  publicCourseCardMetricsLessons: "%(lessonCount) li\u00e7\u00f5es",
  publicCourseCardMetricsOneLesson: "1 li\u00e7\u00e3o",
  publicCourseCardMetricsOneStudent: "1 estudante",
  publicCourseCardMetricsStudents: "%(studentCount) estudantes",
  publicCourseInformationDescription: "Cursos sob demanda que o omegaUp oferece gratuitamente.",
  publicTagsPlaceholder: "Ex. Recurs\u00e3o, \u00c1rvore de segmentos, Pesquisa Bin\u00e1ria",
  qualityFormCongrats: "Parab\u00e9ns por resolver esta problema!",
  qualityFormDifficulty: "Qu\u00e3o dif\u00edcil voc\u00ea achou esse problema?",
  qualityFormDifficultyAny: "Qualquer",
  qualityFormDifficultyEasy: "F\u00e1cil",
  qualityFormDifficultyHard: "Dif\u00edcil",
  qualityFormDifficultyMedium: "M\u00e9dio",
  qualityFormDifficultyVeryEasy: "Muito f\u00e1cil",
  qualityFormDifficultyVeryHard: "Muito dif\u00edcil",
  qualityFormQuality: "Qu\u00e3o bom voc\u00ea diria que esse problema \u00e9?",
  qualityFormQualityAny: "Algum problema",
  qualityFormQualityBad: "Mal",
  qualityFormQualityFair: "Justo",
  qualityFormQualityGood: "Bom",
  qualityFormQualityOnly: "Problemas de qualidade apenas",
  qualityFormQualityVeryBad: "Muito mal",
  qualityFormQualityVeryGood: "Muito bom",
  qualityFormRateBeforeAc: "\u00a1Voc\u00ea j\u00e1 pode avaliar este problema!",
  qualityFormThanksForReview: "Obrigado por voc\u00ea reveja",
  qualityNominationCreatedBy: "Criado por",
  qualityNominationMustHaveSolvedProblem: "Voc\u00ea deve resolver o problema antes de nome\u00e1-lo",
  qualityNominationMustHaveTriedToSolveProblem: "Voc\u00ea deve ter tentado resolver o problema antes de nome\u00e1-lo",
  qualityNominationMustNotHaveSolvedProblem: "Voc\u00ea n\u00e3o deve ter resolvido o problema para poder enviar uma 'nomea\u00e7\u00e3o antes de veredicto AC'",
  qualityNominationNominatedBy: "Nomeado por",
  qualityNominationNotFound: "Nomea\u00e7\u00e3o n\u00e3o foi encontrada",
  qualityNominationProblemHasBeenBanned: "Este problema foi banido. Voc\u00ea n\u00e3o pode atualizar sua visibilidade.",
  qualityNominationProblemHasBeenPromoted: "Este problema foi promovido. Voc\u00ea n\u00e3o pode atualizar sua visibilidade.",
  qualityNominationProblemHasWarning: "Este problema tem um aviso. Voc\u00ea n\u00e3o pode atualizar sua visibilidade.",
  qualityNominationRateProblem: "Avaliar o problema",
  qualityNominationRateProblemDesc: "Se voc\u00ea quiser avaliar o problema mais tarde, clique no link \"Avaliar o problema\"",
  qualityNominationResolutionSuccess: "Nomea\u00e7\u00e3o resolvido com sucesso.",
  qualityNominationShowAll: "Mostre tamb\u00e9m as Nomea\u00e7\u00f5es resolvidas",
  qualityNominationType: "Tipo",
  rankRangeHeader: "Coders com maior score obtido (%(lowCount) a %(highCount))",
  rankScore: "Pontua\u00e7\u00e3o",
  rankSolved: "Problemas",
  rankingNoUsers: "N\u00e3o temos dados para exibir no gr\u00e1fico de Ranking.",
  recordNotFound: "Registro n\u00e3o foi encontrado.",
  registerForContest: "cadastre-se para o concurso",
  registerForContestChallenges: "Desafio",
  registerForContestRules: "Regras",
  registerForCourse: "cadastre-se para o course",
  registrationDenied: "Seu pedido de cadastro foi negado",
  registrationPending: "Seu pedido de cadastro neste concurso est\u00e1 pendente de aprova\u00e7\u00e3o do administrador concurso.",
  registrationPendingCourse: "Seu pedido de cadastro neste curso est\u00e1 pendente de aprova\u00e7\u00e3o do administrador.",
  registrationRejectionFeedback: "O motivo fornecido pelo administrador foi: %(extra_note)",
  reportAnIssue: "Relata um problema",
  reportAnIssueTemplate: "## Comportamiento Esperado\n\n*Describe lo que esperabas que pasara*\n\n## Comportamiento Actual\n\n*Describe lo que pas\u00f3 en lugar de lo que se esperaba*\n\n## Posible Soluci\u00f3n\n\n*No es obligatorio, pero puedes sugerir una manera de arreglar el bug*\n\n## Pasos para reproducir (para bugs)\n\n*Provee un link a un ejemplo, o una lista de pasos detallada de c\u00f3mo reproducir\neste bug.  Incluye el c\u00f3digo que lo reproduce, si es relevante*\n\n1. \n2. \n3. \n4. \n\n## Contexto\n\n*C\u00f3mo te ha afectado este issue? Cu\u00e1l es el objetivo a cumplir?*\n\n*Proveer contexto nos ayuda a encontrar la soluci\u00f3n adecuada*\n\n## Tu ambiente\n\n*Incluye los detalles relevantes acerca del ambiente en el que reprodujiste\neste bug*\n\n* Nombre del navegador (e.g. Chrome 39, node.js 5.4): %(userAgent)\n* Link al sitio en el que este problema pasa: %(referer)\n* Errores en la consola: %(serializedErrors)\n* Captura de pantalla:",
  reportProblemFormAdditionalComments: "Coment\u00e1rios adicionais (opcional):",
  reportProblemFormCases: "Eu acredito que os casos de teste est\u00e3o errados.",
  reportProblemFormDuplicate: "Este \u00e9 um problema duplicado.",
  reportProblemFormLinkToOriginalProblem: "Link para problema original (necess\u00e1rio):",
  reportProblemFormNotAProblemStatement: "N\u00e3o descreve uma declara\u00e7\u00e3o de problema.",
  reportProblemFormOffensive: "\u00c9 ofensivo.",
  reportProblemFormOtherReason: "Outra raz\u00e3o.",
  reportProblemFormPoorlyDescribed: "O problema \u00e9 mal descrito.",
  reportProblemFormQuestion: "Por que voc\u00ea deseja relatar esse problema?",
  reportProblemFormSpam: "\u00c9 spam.",
  reportProblemFormThanksForReview: "Obrigado pelo seu relat\u00f3rio!.",
  requestCoder: "Coder",
  requestDate: "Data de aplica\u00e7\u00e3o",
  requestFeedback: "A solicita\u00e7\u00e3o de feedback foi enviada a todos os administradores",
  requestFeedbackConfirm: "Deseja solicitar feedback ao seu professor para este envio?",
  requestFeedbackMessage: "Preciso de sua ajuda nesta submiss\u00e3o.",
  resourceNotFound: "Recurso n\u00e3o encontrado.",
  reviewerNomination: "Qualificar o problema como revisor",
  reviewerNominationFormTitle: "Qualifica esse problema!",
  reviewerNominationQuality: "\u00c9 un problema de calidade?",
  runCannotBeDisqualified: "O envio n\u00e3o pode ser desqualificado",
  runCannotBeRequalified: "O envio n\u00e3o pode ser requalificado",
  runDetailsCompilationError: "Erro de compila\u00e7\u00e3o",
  runDetailsCorrect: "Correto",
  runDetailsExceeded: "limite excedido",
  runDetailsFeedbackAddReview: "Adicionar feedback",
  runDetailsFeedbackCancel: "Cancelar",
  runDetailsFeedbackPlaceholder: "Digite seu feedback aqui...",
  runDetailsFeedbackThreadPlaceholder: "Responder...",
  runDetailsFinished: "Conclu\u00eddo",
  runDetailsIncorrect: "Incorreto",
  runDetailsInterrupted: "Interrompido",
  runDetailsJudgeError: "Erro do juiz",
  runDetailsNewFeedback: "Novo feedback",
  runDetailsNotAvailable: "N\u00e3o dispon\u00edvel",
  runDetailsRuntimeError: "Erro de execu\u00e7\u00e3o",
  runDetailsRuntimeFunctionError: "Erro de fun\u00e7\u00e3o restrita",
  runDetailsValidatorError: "Erro do validador",
  runDisqualifyByProblemConfirm: "Voc\u00ea realmente deseja desclassificar todas as execu\u00e7\u00f5es para este problema no concurso para este usu\u00e1rio?",
  runDisqualifyByUserConfirm: "Voc\u00ea realmente deseja desqualificar todas as execu\u00e7\u00f5es do concurso para este usu\u00e1rio?",
  runDisqualifyConfirm: "Voc\u00ea realmente deseja desqualificar este envio?",
  runGUID: "GUID",
  runNotEvenOpened: "Voc\u00ea deve abrir o problema antes de tentar apresentar uma solu\u00e7\u00e3o.",
  runNotFound: "Run n\u00e3o encontrado",
  runNotInsideContest: "Tempo de concurso expirou ou n\u00e3o foi iniciado ainda.",
  runWaitGap: "Voc\u00ea tem que esperar entre solu\u00e7\u00f5es consecutivas.",
  schoolNotFound: "Escola n\u00e3o encontrada",
  schoolNotSelected: "Nenhuma escola selecionada",
  schoolOfTheMonth: "Escola do M\u00eas",
  schoolOfTheMonthAlreadySelected: "A escola do m\u00eas foi selecionada anteriormente",
  schoolOfTheMonthChooseAsSchool: "Escolha como Escola do M\u00eas",
  schoolOfTheMonthIsNotInPeriodToBeChosen: "A escola do m\u00eas n\u00e3o est\u00e1 no per\u00edodo a ser escolhida",
  schoolOfTheMonthNotFound: "N\u00e3o foi encontrado a escola do m\u00eas.",
  schoolOfTheMonthSelectedSuccessfully: "A escola do m\u00eas foi selecionada com sucesso!",
  schoolOfTheMonthSystemInMaintainance: "O sistema de Escola do M\u00eas est\u00e1 em manuten\u00e7\u00e3o.\n\nVoltaremos em breve.",
  schoolRankOfTheMonthHeader: "As melhores %(count) escolas com maior pontua\u00e7\u00e3o do m\u00eas",
  schoolRankRangeHeader: "Escolas com maior score obtido (%(lowCount) a %(highCount))",
  schoolUsers: "Coders que pertencem a esta escola",
  schoolsCreateCoursesThatMeetNeeds: "Cursos que atendem \u00e0s suas necessidades. Voc\u00ea pode criar seus pr\u00f3prios problemas.",
  schoolsCreateYourCourse: "Crie seus cursos",
  schoolsCreateYourProblems: "Crie seus problemas",
  schoolsLearnProgBySolvProblems: "Aprender programa\u00e7\u00e3o resolvendo problemas",
  schoolsManageProgressOfStudents: "Gerencie o progresso de seus alunos",
  schoolsOfTheMonth: "Escolas do M\u00eas",
  schoolsOfTheMonthCandidates: "Candidatas a Escola do M\u00eas",
  schoolsOfTheMonthRank: "As melhores 100 escolas do m\u00eas anterior",
  schoolsStartUsingCourses: "Come\u00e7ar a usar cursos",
  scoreboardAccountName: "Nome da conta",
  scoreboardLastUpdated: "\u00daltima atualiza\u00e7\u00e3o: %(datetime)",
  scoreboardNameAndAccountName: "Nome e nome da conta",
  scoreboardShowOnlyInvitedIdentities: "Mostre somente os concorrentes oficiais",
  scoreboardShowParticipantsNames: "Mostrar nomes dos participantes",
  searchUser: "Pesquisar coder",
  selectProblemLevelDesc: "Para adicionar o problema, voc\u00ea deve escolher o n\u00edvel correspondente",
  serviceUnavailableError: "Oops. O servi\u00e7o n\u00e3o est\u00e1 dispon\u00edvel no momento. Por favor, tente novamente mais tarde.",
  settingsExtraWallTime: "Tempo Extra",
  settingsInteractive: "Interativo",
  settingsLanguage: "Linguagem de Programa\u00e7\u00e3o",
  settingsMemoryLimit: "Limite de Mem\u00f3ria",
  settingsModuleName: "Nome do M\u00f3dulo",
  settingsOutputLimit: "Limite de Sa\u00edda",
  settingsOverallWallTimeLimit: "Limite de Tempo (Total)",
  settingsTimeLimit: "Limite de Tempo",
  settingsTolerance: "Toler\u00e2ncia",
  settingsValidator: "Validador",
  showDefaultAllContestantsInScoreboard: "Mostrar todos os competidores no painel de avalia\u00e7\u00e3o.",
  showLinks: "V\u00ednculos",
  showTotalScoreboard: "Mostre o painel total",
  signUpFormInteractiveGuideConfirmPassword: "Confirme sua senha",
  signUpFormInteractiveGuideEmail: "Digite seu e-mail",
  signUpFormInteractiveGuidePassword: "Crie sua senha, minimo de 8 caracteres",
  signUpFormInteractiveGuideRegister: "Conclua o registro",
  signUpFormInteractiveGuideTermsAndConditions: "Leia e aceite os termos e condi\u00e7\u00f5es",
  signUpFormInteractiveGuideTitle: "Inscrever-se",
  signUpFormInteractiveGuideUsername: "Escolha o nome da sua conta, s\u00f3 s\u00e3o permitidas letras mai\u00fasculas, min\u00fasculas, n\u00fameros e os caracteres _, . e -, e o n\u00famero m\u00ednimo de caracteres \u00e9 2.",
  signUpFormInteractiveGuideWelcome: "Vamos criar sua conta! \ud83d\udc4b",
  singleUserAddSuccess: "Conta adicionada com sucesso.",
  socketStatusConnected: "Soquete est\u00e1 conectado",
  socketStatusFailed: "A conex\u00e3o do soquete falhou",
  socketStatusWaiting: "Esperando pela conex\u00e3o do soquete",
  solutionAvailableViews: "Ver vistas disponibles",
  solutionConfirm: "Para olhar a solu\u00e7\u00e3o deste problema por favor clique no bot\u00e3o seguinte.",
  solutionLocked: "Voc\u00ea ainda n\u00e3o consegue ver essa solu\u00e7\u00e3o.\n\n*   Tente resolver o problema primeiro ou voc\u00ea pode desbloque\u00e1-lo caso ainda n\u00e3o tenha atingido o limite de solu\u00e7\u00f5es visualizadas por dia.\n*   Depois de decidir desbloquear a solu\u00e7\u00e3o de um problema, ela n\u00e3o contar\u00e1 na sua pontua\u00e7\u00e3o no ranking do omegaUp.",
  solutionNotFound: "A solu\u00e7\u00e3o para esse problema ainda n\u00e3o foi adicionada.",
  solutionNotLoggedIn: "Voc\u00ea deve fazer o login para desbloquear/visualizar esta solu\u00e7\u00e3o.",
  solutionViewsLeft: "Voc\u00ea ainda tem **%(available)** visualiza\u00e7\u00f5es dispon\u00edveis, de um total de **%(total)** que voc\u00ea pode gerar por dia.",
  spinnerLoadingMessage: "Carregando...",
  startContest: "Iniciar concurso",
  startCourse: "Iniciar curso",
  statementLanguage: "Idioma",
  statementLanguageEn: "Ingl\u00eas",
  statementLanguageEs: "Espanhol",
  statementLanguagePt: "Portugu\u00eas",
  statementNotFound: "Declara\u00e7\u00e3o do problema n\u00e3o foi encontrado.",
  studentCourseInformationDescription: "Aqui voc\u00ea encontrar\u00e1 a lista de cursos nos quais est\u00e1 matriculado.",
  studentProgressDescriptionTotalPoints: "(%(points) pontos + %(extraPoints) extra)",
  studentProgressExtraProblem: "(extra)",
  studentProgressOnlyLecturesDescription: "Este conte\u00fado inclui apenas leituras",
  studentProgressPoints: "(%(points) pontos)",
  studentProgressTooltipDescription: "%(problem):\n\n%(score) of %(points) pontos (%(progress)% de progresso)",
  studentsProgressRangeHeader: "Progresso dos estudantes (do %(lowCount) ao %(highCount))",
  submissionFeedbackAlreadyExists: "J\u00e1 existe um feedback para esta submis\u00e3o.",
  submissionFeedbackAnimationButton: "Deixe seu feedback linha por linha como mostrado na anima\u00e7\u00e3o:",
  submissionFeedbackParticipantsListEmpty: "A lista de participantes neste t\u00f3pico est\u00e1 vazia.",
  submissionFeedbackSendButton: "Deixar feedback \ud83d\udd3d",
  submissionMemoryInMegabytes: "%(value) MiB",
  submissionNotFound: "Envio n\u00e3o encontrado.",
  submissionRunTimeInSeconds: "%(value) s",
  submissionSendFeedback: "Enviar feedback",
  submissionsListCoder: "Coder",
  submissionsListTitle: "Submiss\u00f5es realizadas nas \u00faltimas 24 horas",
  submitFeedbackCancel: "Cancelar",
  submitFeedbackPlaceholder: "Insira seus coment\u00e1rios (opcional)",
  submitFeedbackRequireConfirmation: "Enviar coment\u00e1rios",
  submitFeedbackSubmit: "Enviar",
  supportAssignUserRoles: "Atribuir fun\u00e7\u00f5es",
  supportContestRemovedFromRecommended: "O concurso foi removido dos recomendados",
  supportContestSetAsRecommended: "O concurso foi definido como recomendado",
  supportNewSearch: "Nova pesquisa",
  supportOptions: "Op\u00e7\u00f5es",
  supportSetAsRecommended: "Definir como recomendado",
  supportTypeContestAlias: "Digite o alias do concurso",
  supportTypeEmailOrUsername: "Digite o e-mail ou nome de usu\u00e1rio",
  tagAdded: "Tag adicionado com sucesso!",
  tagNotFound: "Etiqueta n\u00e3o encontrada",
  tagPrefixRestricted: "O prefixo 'problemTag' n\u00e3o pode ser usado para tags adicionados manualmente.",
  tagRemoved: "Tag exclu\u00eddo com sucesso!",
  tagRestricted: "A tag n\u00e3o pode ser adicionada ou exclu\u00edda.",
  tagSourceLevel: "Nivel",
  tagSourceOwner: "Etiqueta do autor",
  tagSourceVoted: "Etiqueta dos coders",
  teamAliasInUse: "H\u00e1 pelo menos um alias de equipe duplicado. Verifique o arquivo CSV para corrigir as informa\u00e7\u00f5es.",
  teamMemberExceededNumberOfContestants: "O n\u00famero de competidores em uma das equipes excede o m\u00e1ximo permitido",
  teamMemberUsernameInUse: "H\u00e1 pelo menos um nome de conta duplicado nas equipes do grupo. Por favor, corrija as informa\u00e7\u00f5es.",
  teamsGroupAliasMustBeRequired: "Em um concurso para equipes, o alias deve ser exigido",
  teamsGroupCreateIdentitiesAsTeams: "Criar identidades como equipes",
  teamsGroupCreatingIdentitiesAsTeams: "Criando identidades como equipes",
  teamsGroupEditGroupUpdated: "O grupo de equipes foi atualizado com sucesso.",
  teamsGroupEditTeams: "Equipes",
  teamsGroupEditTeamsPasswordUpdated: "Senha atualizada corretamente!",
  teamsGroupEditTeamsRemoved: "Equipe removido com sucesso!",
  teamsGroupEditTeamsUpdated: "Equipe atualizado com sucesso!",
  teamsGroupEditTitleWithName: "Editar grupo de equipes %(name)",
  teamsGroupFormCreate: "Criar grupo de equipes",
  teamsGroupFormUpdate: "Salvar altera\u00e7\u00f5es",
  teamsGroupMemberChangePassword: "Digite a nova senha",
  teamsGroupMembersAccountName: "Nome da conta",
  teamsGroupNewFormDescription: "Descri\u00e7\u00e3o do grupo de equipes",
  teamsGroupTeamName: "Nome de equipe",
  teamsGroupTeamsAdvancedOptions: "Op\u00e7\u00f5es avan\u00e7adas",
  teamsGroupTeamsEmptyList: "N\u00e3o h\u00e1 equipes neste grupo",
  teamsGroupTeamsGroupName: "Nome de grupo de equipes",
  teamsGroupTeamsSelfGenerateIdentities: "Autogerar identidades",
  teamsGroupUploadIdentitiesAsTeams: "Subir equipes",
  teamsGroupUsernames: "Coders",
  teamsGroupsCanNotBeAddedInNormalContest: "Os grupos de equipes n\u00e3o podem ser adicionados em concursos normales",
  teamsGroupsCreateNew: "Criar novo grupo de equipes",
  teamsGroupsCsvHelp: "## Adicione rapidamente v\u00e1rias identidades como equipes a este grupo. As identidades n\u00e3o s\u00e3o contas normais e n\u00e3o precisam ter um email ou validar sua conta.\n\n## As identidades devem estar em um arquivo `.csv` com o seguinte formato:\n```\nusername,name,country_id,state_id,gender,school_name\nteam-1,Team 1,MX,AGU,decline,Best School\nteam-2,Teams 2,MX,AGU,other,Best School\n```",
  teamsGroupsCsvHelpMoreInfo: "\u2139\ufe0f Mais informa\u00e7\u00f5es",
  teamsGroupsErrorFieldIsNotPresentInCsv: "Alguns campos obrigat\u00f3rios n\u00e3o foram encontrados no arquivo csv: %(missingFields)",
  teamsGroupsErrorFieldIsRequired: "O campo %(field) \u00e9 obrigat\u00f3rio.",
  titleInUse: "T\u00edtulo j\u00e1 existe. Por favor, escolha um t\u00edtulo diferente. ",
  tokenDecodeCorrupted: "Ocorreu um problema ao decodificar o token.",
  tokenDecodeExpired: "O token que voc\u00ea est\u00e1 tentando usar j\u00e1 expirou.",
  tokenDecodeInvalid: "O token n\u00e3o pertence a este curso.",
  tokenDecodeUnknown: "O token n\u00e3o \u00e9 v\u00e1lido para este curso.",
  totalRuns: "Execu\u00e7\u00f5es totais: %(numRuns)",
  typeaheadSearchPlaceholder: "Pesquisar...",
  unableToVerifyCaptcha: "N\u00e3o pudemos verificar o captcha. Recarregue a p\u00e1gina e tente novamente",
  under13UserException: "Voc\u00ea n\u00e3o pode ingressar a este s\u00edtio usando uma conta para crian\u00e7as menores de 13 anos de idade",
  unnecessaryTokenForPublicCourses: "O token \u00e9 desnecess\u00e1rio para cursos p\u00fablicos",
  unsupportedBrowser: "Seu navegador n\u00e3o suporta todos os recursos desta p\u00e1gina. Por favor tente atualizar a um <a href=\"https://github.com/omegaup/omegaup#navegadores-soportados\" target=\"blank\">navegador suportado</a>.",
  unverifiedUser: "Conta n\u00e3o verificada.",
  updateItemsSuccess: "Todos os itens selecionados foram atualizados",
  updateProblemLevel: "Atualizar o n\u00edvel do problema",
  updateStatementsCommitMessage: "Atualizando elabora\u00e7\u00e3oes",
  userAlreadyAcceptedPrivacyPolicy: "Esta conta j\u00e1 aceitou a pol\u00edtica de privacidade",
  userAlreadyHasSelectedRole: "Esta conta j\u00e1 tem a fun\u00e7\u00e3o selecionada",
  userBirthDate: "Data de nascimento: %(birthDate)",
  userDocsDocumentation: "Documenta\u00e7\u00e3o",
  userDoesNotHaveAnyPasswordChangeRequest: "A conta n\u00e3o possui nenhuma solicita\u00e7\u00e3o de mudan\u00e7a de senha nas \u00faltimas 24 horas.",
  userEditAddPassword: "Adicionar senha",
  userEditBachelors: "Grau",
  userEditBirthDate: "Data de nascimento",
  userEditChangeEmail: "Mude o e-mail",
  userEditChangePassword: "Alterar senha",
  userEditChangePasswordNewPassword: "Nova senha",
  userEditChangePasswordOldPassword: "Senha antiga",
  userEditChangePasswordRepeatNewPassword: "Repita nova senha",
  userEditChangePasswordToUsername: "Alterar senha: %(username)",
  userEditCountry: "Pa\u00eds / Regi\u00e3o",
  userEditDeleteAccount: "Deletar Conta",
  userEditDoctorate: "Doutorado",
  userEditEarlyChildhood: "Primeira inf\u00e2ncia",
  userEditGraduationDate: "Data da gradua\u00e7\u00e3o",
  userEditGravatar: "Carreg\u00e1-lo em Gravatar.com usando seu e-mail: ",
  userEditHideProblemTags: "Ocultar tags de problemas",
  userEditLanguage: "Linguagem",
  userEditLowerSecondary: "Secund\u00e1rio inferior",
  userEditManageSchools: "Gerenciar escolas",
  userEditManageSchoolsUserCurrentlyEnrolled: "Atualmente inscrito",
  userEditMaster: "Mestria",
  userEditNameTooLong: "O nome n\u00e3o pode conter mais de 50 caracteres.",
  userEditNone: "Nenhum",
  userEditPostSecondary: "P\u00f3s-secund\u00e1rio",
  userEditPrePrimary: "Pr\u00e9-prim\u00e1rio",
  userEditPreferences: "Prefer\u00eancias",
  userEditPreferencesSuccess: "Prefer\u00eancias atualizadas com sucesso.",
  userEditPreferredProgrammingLanguage: "Linguagem de programa\u00e7\u00e3o preferida",
  userEditPrimary: "Prim\u00e1ria",
  userEditPrivateProfile: "Gostaria de esconder os detalhes do perfil de outros?",
  userEditProfileImage: "Imagem do perfil",
  userEditSchoolGrade: "Grau de escola",
  userEditSchoolSuccess: "Informa\u00e7\u00e3o da escola atualizada com sucesso.",
  userEditSuccess: "Perfil atualizado com sucesso",
  userEditSuccessfulEmailUpdate: "E-mail atualizado com sucesso! Em alguns minutos, voc\u00ea receber\u00e1 mais instru\u00e7\u00f5es no seu e-mail. N\u00e3o se esque\u00e7a de verificar sua pasta de Spam.",
  userEditTertiary: "Terci\u00e1rio",
  userEditUpperSecondary: "Secund\u00e1rio superior",
  userEditViewProfile: "Veja meu perfil",
  userEmailEditEmail: "E-mail",
  userEmails: "E-mails",
  userEndTimeUpdatedSuccessfully: "O hor\u00e1rio de t\u00e9rmino do concurso foi atualizado corretamente.",
  userGroups: "Grupos",
  userInformationIsPrivate: "A informa\u00e7\u00e3o desta conta \u00e9 privada",
  userLastLogin: "Data do \u00faltimo login: %(lastLogin)",
  userNeverLoggedIn: "Nunca logado.",
  userNextRegisteredContestButtonEnter: "Entrar",
  userNextRegisteredContestButtonSeeDetails: "Ver detalhes",
  userNextRegisteredContestTitle: "Lembre-se de participar no concurso",
  userNotAllowed: "N\u00e3o tem permiss\u00f5es para executar essa a\u00e7\u00e3o",
  userNotAllowedToAddPrivateProblem: "Somente os administradores de problemas podem adicionar seus pr\u00f3prios problemas privados em conjuntos de problemas",
  userNotExist: "A conta n\u00e3o existe",
  userNotInListOfRequests: "Esta conta n\u00e3o esteja pendente pedido",
  userObjectivesModalAnswerCompetitive: "concursos de programa\u00e7\u00e3o",
  userObjectivesModalAnswerLearning: "aprender programa\u00e7\u00e3o",
  userObjectivesModalAnswerLearningAndTeaching: "aprender e ensinar programa\u00e7\u00e3o",
  userObjectivesModalAnswerNone: "nenhuma das anteriores",
  userObjectivesModalAnswerOther: "outro",
  userObjectivesModalAnswerScholar: "aulas escolares",
  userObjectivesModalAnswerScholarAndCompetitive: "aulas e concursos",
  userObjectivesModalAnswerTeaching: "ensinar programa\u00e7\u00e3o",
  userObjectivesModalButtonNext: "Seguinte",
  userObjectivesModalButtonPrevious: "Anterior",
  userObjectivesModalButtonSend: "Enviar",
  userObjectivesModalDescriptionLearning: "Quero aprender para...",
  userObjectivesModalDescriptionLearningAndTeaching: "Quero aprender e ensinar para...",
  userObjectivesModalDescriptionTeaching: "Quero ensinar para...",
  userObjectivesModalDescriptionUsage: "Quero usar o omegaUp para...",
  userObjectivesModalPageCounter: "%(current) de %(last)",
  userObjectivesModalTitle: "Ajude-nos a conhec\u00ea-lo",
  userObjectivesUpdateSuccess: "Obrigado por nos ajudar. Suas respostas foram salvas",
  userOrMailNotFound: "Nome da conta ou e-mail n\u00e3o encontrado",
  userPasswordMustBeSame: "As novas senhas devem ser as mesmas.",
  userProfileIsPrivate: "O perfil desta conta \u00e9 marcado como privado; algumas informa\u00e7\u00f5es n\u00e3o ser\u00e3o exibidas",
  userProfileProblemsFilter: "Filtrar",
  userRankEmptyList: "N\u00e3o h\u00e1 dados para mostrar no ranking",
  userRankLastUpdated: "Ultima atualiza\u00e7\u00e3o: %(datetime)",
  userRankOfTheMonthHeader: "%(count) coders com maior pontua\u00e7\u00e3o do m\u00eas",
  userRankSolvedProblemsHelp: "O n\u00famero de problemas resolvidos \u00e9 atualizado uma vez por dia.",
  userRemoveSuccess: "Conta eliminada com sucesso.",
  userRoles: "Roles",
  userVerified: "A conta foi verificada",
  userVerify: "Verificar a conta",
  username: "Nome da conta",
  usernameInUse: "Este nome de conta j\u00e1 foi utilizado.",
  usernameOrPassIsWrong: "O nome da conta ou a senha est\u00e3o incorretos. Por favor verifique suas credenciais.",
  usersCanNotBeAddedInContestForTeams: "As contas individuais n\u00e3o podem ser adicionadas em concursos para equipes",
  usersCanNotBeAddedInVirtualContestWhenOriginalContestIsPrivate: "N\u00e3o \u00e9 poss\u00edvel adicionar coders a um concurso virtual quando o concurso original \u00e9 privado",
  verdictAC: "Aceitado",
  verdictCE: "Erro de compila\u00e7\u00e3o",
  verdictFO: "Erro de execu\u00e7\u00e3o (fun\u00e7\u00e3o restrita)",
  verdictHelpAC: "Seu programa est\u00e1 correto!",
  verdictHelpCE: "Seu c\u00f3digo falhou ao compilar. Por favor, clique no bot\u00e3o \"Detalhes\" para ver o erro de compila\u00e7\u00e3o.",
  verdictHelpDisqualified: "Um juiz desqualificou esta remessa manualmente",
  verdictHelpFO: "Seu programa tentou executar uma opera\u00e7\u00e3o n\u00e3o permitida no ambiente virtual. Normalmente, isso \u00e9 causado ao chamar system().",
  verdictHelpJE: "Houve um problema com o juiz e n\u00e3o \u00e9 culpa sua. Algu\u00e9m foi informado e deve ser corrigido em breve. Por favor, n\u00e3o envie novamente seu programa porque isso s\u00f3 vai piorar o problema e voc\u00ea pode ser penalizado.",
  verdictHelpKarelRTE: "Karel bateu numa parede, ou ficou sem beepers.",
  verdictHelpKarelTLE: "Karel demorou muito para resolver o problema.",
  verdictHelpML: "Seu programa tentou usar mais mem\u00f3ria do que o problema permite. Tente pensar num algoritmo que usa menos mem\u00f3ria.",
  verdictHelpMLE: "Seu programa tentou usar mais mem\u00f3ria do que o problema permite. Tente pensar num algoritmo que usa menos mem\u00f3ria.",
  verdictHelpOL: "Seu programa produziu uma resposta que est\u00e1 errada em pelo menos um caso. Como dica, voc\u00ea tentou imprimir demais.",
  verdictHelpOLE: "Seu programa produziu uma resposta que est\u00e1 errada em pelo menos um caso. Como dica, voc\u00ea tentou imprimir demais.",
  verdictHelpPA: "Seu programa corretamente resolveu alguns dos casos, mas teve pelo menos um caso errado.",
  verdictHelpRE: "Seu programa terminou inesperadamente (falhou). Muito provavelmente voc\u00ea n\u00e3o considerou pelo menos um caso poss\u00edvel. Isso geralmente \u00e9 causado por acessar um elemento inv\u00e1lido de uma matriz, executando fora do espa\u00e7o do Stack ou tentando declarar uma matriz que \u00e9 muito grande.",
  verdictHelpRFE: "Seu programa tentou executar uma opera\u00e7\u00e3o que n\u00e3o permite que a caixa de areia. Normalmente, isso \u00e9 causado pela tentativa de chamar system().",
  verdictHelpRTE: "Seu programa terminou inesperadamente (falhou). Muito provavelmente voc\u00ea n\u00e3o considerou pelo menos um caso poss\u00edvel. Isso geralmente \u00e9 causado por acessar um elemento inv\u00e1lido de uma matriz, executando fora do espa\u00e7o do Stack ou tentando declarar uma matriz que \u00e9 muito grande.",
  verdictHelpTLE: "Seu programa \u00e9 muito lento e n\u00e3o terminou antes do limite do problema.",
  verdictHelpTO: "Seu programa \u00e9 muito lento e n\u00e3o terminou antes do limite do problema.",
  verdictHelpVE: "Houve um problema com o validador do problema e pode ou n\u00e3o ser sua culpa. Na maioria das vezes, isso acontece porque o seu programa fez algo que o validador n\u00e3o levou em considera\u00e7\u00e3o, mas voc\u00ea deve informar o escritor / organizador do concurso sobre isso.",
  verdictHelpWA: "Seu programa n\u00e3o conseguiu dar a resposta correta para todos os casos. Provavelmente voc\u00ea n\u00e3o considerou alguns casos poss\u00edveis.",
  verdictJE: "Erro do juiz (n\u00e3o reenviar)",
  verdictML: "Limite de mem\u00f3ria excedido",
  verdictMLE: "Limite de mem\u00f3ria excedido",
  verdictOL: "Resposta errada (limite de sa\u00edda excedido)",
  verdictOLE: "Resposta errada (limite de sa\u00edda excedido)",
  verdictPA: "Parcialmente aceitado",
  verdictRE: "Erro de execu\u00e7\u00e3o",
  verdictRFE: "Erro de execu\u00e7\u00e3o (fun\u00e7\u00e3o restrita)",
  verdictRTE: "Erro de execu\u00e7\u00e3o",
  verdictTLE: "Limite de tempo excedido",
  verdictTO: "Limite de tempo excedido",
  verdictVE: "Erro do validador (n\u00e3o reenviar)",
  verdictWA: "Resposta errada",
  verificationEmailBody: "Bem-vindo ao omegaUp! Por favor, clique no seguinte link para entrar e verificar seu e-mail: <a href=\"https://omegaup.com/user/verifyemail/%(verification_id)/\">https://omegaup.com/user/verifyemail/%(verification_id)/</a>",
  verificationEmailSubject: "Bem-vindo ao omegaUp!",
  verificationEmailSuccessfully: "Seu e-mail foi verificado.",
  verificationIdInvalid: "A informa\u00e7\u00e3o sobre a verifica\u00e7\u00e3o fornecida n\u00e3o \u00e9 v\u00e1lido.",
  verificationParentalTokenGoToMyDependents: "Ir para meus dependentes",
  virtualContest: "Concurso virtual",
  virtualContestSuffix: "%(title) [virtual]",
  virtualSuffix: "%(username) [virtual]",
  virtualTitle: "%(title) - Concurso virtual",
  warningPublicSolution: "Aviso: O problema que voc\u00ea acabou de adicionar tem uma solu\u00e7\u00e3o p\u00fablica.",
  wizardDescription: "Siga os passos para encontrar os problemas que lhe interessam!",
  wizardLinkText: "Localizador de problemas",
  wizardPriorityPopularity: "Popularidade",
  wizardStepOne: "Escolha a(s) tag(s) dos temas",
  wizardStepThree: "Escolha sua prioridade",
  wizardStepTwo: "Selecione o intervalo de dificuldade",
  wizardTitle: "Localizador de Problemas",
  wordAccepted: "Aceitado",
  wordsActions: "A\u00e7\u00f5es",
  wordsAddAdmin: "Adicionar admin",
  wordsAddIdentity: "Adicionar identidade",
  wordsAddLecture: "Adicionar leitura",
  wordsAddMember: "Adicionar membro",
  wordsAddProblem: "Adicionar problema",
  wordsAddStudent: "Gerenciar alunos",
  wordsAddStudents: "Adicionar estudantes",
  wordsAddTag: "Adicionar Tag",
  wordsAdmin: "Admin",
  wordsAgree: "Concordo",
  wordsAlias: "Alias",
  wordsAll: "Tudos",
  wordsAnswer: "Resposta",
  wordsAnyLanguage: "Qualquer Linguagem",
  wordsArchiveCourse: "Arquivar curso",
  wordsBack: "Voltar",
  wordsBadgesObtained: "Crach\u00e1s obtidos",
  wordsBadgesSeeAll: "Ver todas as crach\u00e1s dispon\u00edveis",
  wordsBanProblem: "Banir problema",
  wordsBannedProblem: "Problema banido",
  wordsBestSolvers: "Melhores solu\u00e7\u00f5es aceitadas",
  wordsBy: "por",
  wordsCancel: "Cancelar",
  wordsCase: "Caso",
  wordsCases: "Casos",
  wordsClarifications: "Esclarecimentos",
  wordsCloneContest: "Clonar concurso",
  wordsCloneCourse: "Clonar curso",
  wordsCloneThisCourse: "Clonar este curso",
  wordsClose: "Fechar",
  wordsCode: "Codigo",
  wordsCompilerOutput: "Sa\u00edda do compilador",
  wordsCompletedPercentage: "Porcentagem de conclus\u00e3o",
  wordsConfirm: "Confirme",
  wordsConsole: "Console",
  wordsContent: "Conte\u00fado",
  wordsContentEdit: "Editar conte\u00fado",
  wordsContentType: "Tipo de conte\u00fado",
  wordsContest: "Concurso",
  wordsContests: "Concursos",
  wordsContestsResults: "Results",
  wordsCopyToClipboard: "Copiar para o clipboard",
  wordsCountry: "Pa\u00eds",
  wordsCountryRegion: "Pa\u00eds / Regi\u00e3o",
  wordsCourseContent: "Conte\u00fado do curso",
  wordsDangerZone: "Zona de Perigo",
  wordsDangerZoneDesc: "Remova o problema.\n\nIsso s\u00f3 pode ser feito se o problema n\u00e3o tiver sido usado em um curso ou concurso.\n\nVoc\u00ea deve ter muita certeza de que deseja faz\u00ea-lo, porque n\u00e3o h\u00e1 como recuper\u00e1-lo uma vez que ele \u00e9 removido.",
  wordsDate: "Data",
  wordsDelete: "Excluir",
  wordsDeleted: "Exclu\u00eddo",
  wordsDenied: "Denied",
  wordsDescription: "Descri\u00e7\u00e3o",
  wordsDetailed: "Detalhado",
  wordsDetails: "Detalhes",
  wordsDifference: "Diferen\u00e7a",
  wordsDifficulty: "Dificuldade",
  wordsDownload: "Baixar",
  wordsDownloadCode: "Baixar c\u00f3digo",
  wordsDownloadDetails: "Baixar .zip com sa\u00eddas",
  wordsDownloadOutput: "Baixar saida ",
  wordsDueDate: "Data de entrega",
  wordsDuration: "Dura\u00e7\u00e3o",
  wordsEdit: "Editar",
  wordsEditCourse: "Editar curso",
  wordsEmpty: "Vazio",
  wordsEmptyAddStudentInput: "O campo de entrada est\u00e1 vazio, por favor digite um nome de conta",
  wordsEnable: "Habilitar",
  wordsEndTime: "Fim",
  wordsEndTimeContest: "Hora de t\u00e9rmino",
  wordsEnglish: "Ingl\u00eas",
  wordsExam: "Prova",
  wordsExecution: "Execu\u00e7\u00e3o",
  wordsExperiments: "Experimentos",
  wordsExtraWallTimeMs: "Tempo extra para libinteractive (ms)",
  wordsFeedback: "Feedback sobre envios",
  wordsFilterByCountry: "Filtrar pelo meu pa\u00eds / regi\u00e3o",
  wordsFilterByHomework: "Filtrar por tarefa",
  wordsFilterByLanguage: "Filtrar por idioma",
  wordsFilterByProblem: "Filtrar por problema",
  wordsFilterBySchool: "Filtrar pela minha escola",
  wordsFilterByState: "Filtrar por meu estado",
  wordsGender: "G\u00eanero",
  wordsGenderDecline: "Eu prefiro n\u00e3o responder",
  wordsGenderFemale: "Feminino",
  wordsGenderMale: "Masculino",
  wordsGenderOther: "Outros",
  wordsGetToKnowOurCourses: "Conhece nossos cursos",
  wordsGlobalSubmissions: "Envios globais",
  wordsGroup: "Grupo",
  wordsGroupAdmin: "Grupo de admins",
  wordsGroups: "Grupos",
  wordsHighQualityProblem: "Este problema recebeu um distintivo de Alta Qualidade por um comit\u00ea de revisores omegaUp",
  wordsHomework: "Tarefa",
  wordsID: "ID",
  wordsIdentities: "Identidades",
  wordsIdentity: "Identidade",
  wordsInOut: "Entrada/Sa\u00edda",
  wordsInput: "Entrada",
  wordsJudgedBy: "Validado pela",
  wordsJustOutput: "S\u00f3 sa\u00edda",
  wordsKarel: "Karel",
  wordsKeepProblem: "Mantener el problema",
  wordsKeyword: "Palavra-chave",
  wordsKeywordSearch: "Pesquise por alias, t\u00edtulo ou ID do problema",
  wordsLanguage: "Idioma",
  wordsLanguages: "Idioma",
  wordsLatestSubmissions: "\u00daltimos env\u00edos",
  wordsLecture: "Leitura",
  wordsLesson: "Li\u00e7\u00e3o",
  wordsLevel: "N\u00edvel",
  wordsLogs: "Log de execu\u00e7\u00e3o",
  wordsMember: "Membro",
  wordsMemory: "Mem\u00f3ria",
  wordsMemoryInMebibytes: "Mem\u00f3ria (MiB)",
  wordsMessage: "Mensagem",
  wordsMessageTo: "Mensagem para",
  wordsMonths: "Meses",
  wordsMultipleUser: "M\u00faltiplas contas (separadas por v\u00edrgulas ou nova linha)",
  wordsMyClarifications: "Minhas clarifica\u00e7\u00f5es",
  wordsMyContests: "Meus Concursos",
  wordsMyScore: "Minha pontua\u00e7\u00e3o",
  wordsName: "Nome",
  wordsNewClarification: "Nova clarifica\u00e7\u00e3o",
  wordsNewSubmissions: "Nova submiss\u00e3o",
  wordsNext: "Seguinte",
  wordsNextPage: "P\u00e1gina seguinte",
  wordsNo: "N\u00e3o",
  wordsNoComment: "N\u00e3o coment\u00e1rios",
  wordsNoSubmissions: "Leitura (Sem submiss\u00f5es)",
  wordsNone: "Nada",
  wordsNotApplicable: "N/A",
  wordsNumHomeworks: "N\u00famero de tarefas",
  wordsNumTests: "N\u00famero de exames",
  wordsNumberOfContestants: "N\u00famero de participantes",
  wordsOnlyExamples: "Apenas exemplos",
  wordsOptional: "Opcional",
  wordsOther: "Outro",
  wordsOutOf4: "%(Score) de 4",
  wordsOutput: "Sa\u00edda",
  wordsPenalty: "Penaliza\u00e7\u00e3o",
  wordsPending: "Pendente",
  wordsPendingRuns: "Envios pendentes",
  wordsPercentage: "Porcentagem",
  wordsPoints: "Pontos",
  wordsPointsDistribution: "Distribui\u00e7\u00e3o da pontua\u00e7\u00e3o do concurso: %(alias)",
  wordsPointsDistributionInIntervals: "Distribui\u00e7\u00e3o da pontos em intervalos do 100",
  wordsPointsDistributionProblem: "Distribui\u00e7\u00e3o da pontua\u00e7\u00e3o do problema: %(alias)",
  wordsPointsForRank: "Pontos para o ranking",
  wordsPointsForRankTooltip: "Estes pontos representam o valor real deste problema. Resolverlo diminue o seu valor. Para mais detalhes, siga este link.",
  wordsPortuguese: "Portugu\u00eas",
  wordsPractice: "Pratica",
  wordsPrevPage: "P\u00e1gina anterior",
  wordsPrevious: "Anterior",
  wordsPrivacyPolicy: "Pol\u00edtica de privacidade",
  wordsPrivacyPolicyAccepted: "Voc\u00ea aceitou a pol\u00edtica de privacidade",
  wordsPrivate: "Privado",
  wordsPrivateTags: "Tags privados",
  wordsProblem: "Problema",
  wordsProblemOrSolutionNotExist: "O problema ou a solu\u00e7\u00e3o nao existem.",
  wordsProblems: "Problemas",
  wordsProblemsetter: "Proposto por",
  wordsProgress: "Progresso",
  wordsProportion: "Propor\u00e7\u00e3o",
  wordsPublic: "P\u00fablico",
  wordsPublicTags: "Tags p\u00fablicos",
  wordsPublicUpdated: "Atualizado",
  wordsQuality: "Qualidade",
  wordsRanking: "Ranking",
  wordsRankingMeasurement: "Como funciona a classifica\u00e7\u00e3o?",
  wordsRatio: "Ratio",
  wordsReadAgain: "Leia de novo",
  wordsReadMore: "ler mais",
  wordsReason: "Raz\u00e3o",
  wordsRegistration: "Registro/aberto",
  wordsRemoveFilter: "Remover filtros",
  wordsReportProblem: "Relatar problema",
  wordsRequired: "Obrigat\u00f3rio",
  wordsReset: "omegaUp: Redefini\u00e7\u00e3o de senha.",
  wordsResetMessage: "Clique no link abaixo para redefinir sua senha: <a href=\"[link]\">[link]</a><br><br> Se voc\u00ea n\u00e3o solicitou esta opera\u00e7\u00e3o por favor, n\u00e3o clique no link e certifique-se a sua conta est\u00e1 a salvo.",
  wordsResult: "Resposta",
  wordsReviewingProblem: "Revendo o problema",
  wordsRun: "Executar",
  wordsRuns: "Execu\u00e7\u00f5es",
  wordsRuntime: "Tempo de execu\u00e7\u00e3o",
  wordsSaveChanges: "Salvar altera\u00e7\u00f5es",
  wordsSaveNewOrder: "Salvar nova ordem",
  wordsSchool: "Escola",
  wordsScore: "Pontua\u00e7\u00e3o",
  wordsScoreboard: "Painel de avalia\u00e7\u00e3o",
  wordsSearch: "Pesquisar",
  wordsSearchBy: "Procura por",
  wordsSeeCourse: "Ver o curso",
  wordsSeeGeneralRanking: "Ver o ranking geral",
  wordsSeeLatestSubmissions: "Ver as \u00faltimas submiss\u00f5es realizadas pelo %(username)",
  wordsSeeSolution: "Ver Solu\u00e7\u00e3o",
  wordsSelectFilter: "Selecione um filtro",
  wordsSend: "Enviar",
  wordsShowCasesDiff: "Mostrar diferen\u00e7as nos casos",
  wordsShowSiteAdmins: "Mostrar site-admins",
  wordsSource: "Fonte",
  wordsSpanish: "Espanhol",
  wordsStart: "Come\u00e7ar",
  wordsStartTime: "Iniciar",
  wordsStatistics: "Estat\u00edsticas",
  wordsStatus: "Status",
  wordsSubmissionDate: "Data de solu\u00e7\u00e3o",
  wordsSubmissions: "Solu\u00e7\u00f5es",
  wordsSubmissionsNotYetReviewed: "Submiss\u00f5es ainda n\u00e3o revisadas",
  wordsSubmit: "Enviar",
  wordsSummary: "Resumo",
  wordsTime: "Data e Hora",
  wordsTimeInSeconds: "Tempo (Seg)",
  wordsTitle: "T\u00edtulo",
  wordsTotal: "Total",
  wordsTotalVotes: "votos totais",
  wordsUnarchiveCourse: "Desarquivar curso",
  wordsUnlimitedDuration: "Dura\u00e7\u00e3o ilimitada",
  wordsUnlockSolution: "Desbloquear Solu\u00e7\u00e3o",
  wordsUpdateLecture: "Atualizar leitura",
  wordsUpdateProblem: "Atualizar problema",
  wordsUpload: "Carregar",
  wordsUploadedOn: "Problema carregado em: %(date)",
  wordsUsersFeedback: "Feedback dos coders",
  wordsVerdict: "Verdito",
  wordsVerdictsOf: "Veredictos de %(alias)",
  wordsWallTimeInSeconds: "Tempo-real (Seg)",
  wordsWarningProblem: "Mantener com um aviso",
  wordsYes: "Sim",
  zipPrepare: "Preparar arquivo zip",
};

export {translations as default};